/**
 * 界面英文译文（M7-06）：键是代码里的简体中文原文，值是英文。新增或修改 t('…') 文案时同步补这里；
 * `src/i18n/coverage.test.ts` 会检查代码中每条文案都有译文。
 */
const en: Record<string, string> = {
  '业务系统 FTP / SFTP · {0}': 'Business system FTP / SFTP · {0}',
  '连接的默认目录': "the connection's default directory",
  '高级设置（远程目录与超时）': 'Advanced (remote directory and timeout)',
  '请检查表单中标红的字段': 'Please check the fields marked in red',
  '用户名大写': 'Username in upper case',
  '撤销移除': 'Undo removal',
  '移除已保存的证书': 'Remove the saved certificate',
  '保存后将删除已保存的客户端证书': 'The saved client certificate will be deleted when you save',
  " · 主键": " · primary key",
  " · 启用时固定": " · pinned at enable time",
  " 等 {0} 个": " and {0} more",
  "(原始)": "(original)",
  "(默认)": "(default)",
  "/{0} 票已发送": "/{0} documents sent",
  "0 为可选（C），1 及以上为必备（M）": "0 = conditional (C), 1 or more = mandatory (M)",
  "12 数据元值无效": "12 Invalid value",
  "13 缺少必需项": "13 Missing",
  "14 值在此位置不支持": "14 Value not supported in this position",
  "15 段/元素在此位置不支持": "15 Not supported in this position",
  "16 组成元素过多": "16 Too many constituents",
  "2 语法版本或级别不支持": "2 Syntax version or level not supported",
  "24 小时": "24 hours",
  "35 重复次数过多": "35 Too many repetitions",
  "37 含无效字符": "37 Invalid character set",
  "3DES（仅兼容老系统）": "3DES (legacy systems only)",
  "7 天": "7 days",
  "<p class=\"muted\">无</p>": "<p class=\"muted\">None</p>",
  "<业务事件密钥>": "<business-event-key>",
  "<业务系统幂等号>": "<idempotency-key>",
  "<交换引擎地址>": "<exchange-engine-host>",
  "<伙伴编码>": "<partner-code>",
  "<保存后生成的端口编号>": "<port number generated on save>",
  "<租户>": "<tenant>",
  "AI 助手": "AI assistant",
  "APERAK 或业务应答：对方是否在业务上受理": "APERAK or business response: whether the partner accepted it for processing",
  "AS2 配置": "AS2 settings",
  "Authorization: Bearer <令牌>": "Authorization: Bearer <token>",
  "Basic 认证": "Basic authentication",
  "Basic 认证（放入请求头）": "Basic authentication (request header)",
  "Bearer 令牌": "Bearer token",
  "CA 证书 (PEM)": "CA certificate (PEM)",
  "CONTRL 是 EDIFACT 的语法回执，说明整个交换和每份报文在语法上是否被接受": "CONTRL is the EDIFACT syntax acknowledgement: whether the interchange and each message were accepted syntactically",
  "CONTRL：对方是否在语法上接受了交换": "CONTRL: whether the partner accepted the interchange syntactically",
  "CSV 文件解析失败": "Failed to parse the CSV file",
  "DB2": "DB2",
  "EDI 工作流编辑器使用指南": "EDI workflow editor guide",
  "EDI 联调测试报告": "EDI Test Report",
  "EDI 自由布局画布指南": "EDI free-layout canvas guide",
  "FTP / FTPS": "FTP / FTPS",
  "FTPS（显式 TLS）": "FTPS (explicit TLS)",
  "FTPS（隐式 TLS）": "FTPS (implicit TLS)",
  "FTP（明文）": "FTP (plain)",
  "FTP（明文，仅专线）": "FTP (plain, private lines only)",
  "HTTP / REST": "HTTP / REST",
  "HTTP 代理主机": "HTTP proxy host",
  "HTTP 代理端口": "HTTP proxy port",
  "HTTP 接口": "HTTP API",
  "HTTP 接收": "HTTP receive",
  "HTTPS 地址、邮箱或手机号，多个用逗号隔开": "HTTPS URLs, e-mail addresses or mobile numbers, comma-separated",
  "HTTPS 地址，多个用逗号隔开": "HTTPS URLs, comma-separated",
  "IBM DB2 关系型数据库": "IBM DB2 relational database",
  "JSON 格式无效，修正后再切换回表单": "Invalid JSON; fix it before switching back to the form",
  "MD5（遗留兼容）": "MD5 (legacy)",
  "MDN 方式": "MDN mode",
  "MDN 超时": "MDN timeout",
  "MariaDB": "MariaDB",
  "MariaDB 开源关系型数据库": "MariaDB open-source relational database",
  "Microsoft SQL Server 数据库": "Microsoft SQL Server database",
  "MySQL": "MySQL",
  "OAuth2 客户端凭据": "OAuth2 client credentials",
  "OFTP2 执行器尚未接入，当前只能保存配置。": "The OFTP2 executor is not connected yet; configuration can only be saved.",
  "OFTP2 执行器未接入，仅允许保存配置": "The OFTP2 executor is not connected; configuration can only be saved",
  "Oracle": "Oracle",
  "Oracle Database，支持服务名或 SID": "Oracle Database, supports service name or SID",
  "PFX 密码": "PFX password",
  "PostgreSQL": "PostgreSQL",
  "SFTP": "SFTP",
  "SHA-1（兼容模式）": "SHA-1 (compatibility)",
  "SI 截单：开航前（小时）": "SI cut-off: hours before departure",
  "SLA 超时": "SLA breached",
  "SQL Server": "SQL Server",
  "SSH 主机密钥材料 ID": "SSH host key material ID",
  "SSL 加密模式": "SSL encryption mode",
  "TLS 模式": "TLS mode",
  "TLS 私钥证书": "TLS private key certificate",
  "UN/EDIFACT D.24A 官方目录": "UN/EDIFACT D.24A official directory",
  "UNB 缺少交换控制号": "UNB has no interchange control reference",
  "UNOA 大写字母数字": "UNOA upper-case alphanumeric",
  "UNOB 大小写字母数字": "UNOB mixed-case alphanumeric",
  "UNOC Latin-1（航运常用）": "UNOC Latin-1 (common in shipping)",
  "UNT 参考号与 UNH 不符": "UNT reference does not match UNH",
  "UNT 段数不符": "UNT segment count mismatch",
  "UNZ 之后还有内容": "Content after UNZ",
  "UNZ 报文数不符": "UNZ message count mismatch",
  "UNZ 控制号与 UNB 不符": "UNZ control reference does not match UNB",
  "URL 预览": "URL preview",
  "UTC 标准时间: {0}": "UTC: {0}",
  "VERIFY 模式下验证服务器证书；留空使用系统信任库": "Validates server certificate in VERIFY mode; leave blank to use system truststore",
  "VGM 截单：开航前（小时）": "VGM cut-off: hours before departure",
  "VGM 申报": "VGM declaration",
  "Webhook / 群机器人": "Webhook / group bot",
  "X-EDI-Message-Id：报文编号，业务系统据此去重": "X-EDI-Message-Id: message ID, used by the business system to de-duplicate",
  "X25519（密钥交换）": "X25519 (key exchange)",
  "[预警转工单] {0}": "[Alert → work order] {0}",
  "http://业务系统/api/bookings": "http://business-system/api/bookings",
  "https://<网关地址>/edi/v1/inbound/": "https://<gateway-host>/edi/v1/inbound/",
  "https://业务系统/edi/bookings": "https://business-system/edi/bookings",
  "messageId、routeId、messageType、senderCode、receiverCode、payload（映射后的业务数据）": "messageId, routeId, messageType, senderCode, receiverCode, payload (mapped business data)",
  "v{0} 草稿未发布，运行中为 {1}；发布后对使用该协议的全部伙伴生效。": "v{0} draft not published, running {1}; publishing applies it to every partner using this protocol.",
  "{0} {1} 报文": "{0} {1} message",
  "{0} · {1} {2} 次": "{0} · {1} {2}",
  "{0} · 共 {1} 次": "{0} · {1} total",
  "{0} · 已完成 {1}/{2}": "{0} · {1}/{2} done",
  "{0} · 控制号 {1} · {2} 份报文 · {3}": "{0} · control ref {1} · {2} messages · {3}",
  "{0} · 耗时 {1}": "{0} · took {1}",
  "{0} · 重试 {1} 次": "{0} · {1} retries",
  "{0} · 键 {1}": "{0} · key {1}",
  "{0} ·{1} {2} 小时内": "{0} ·{1} within {2} h",
  "{0} 个旧版本": "{0} older versions",
  "{0} 个流程": "{0} workflows",
  "{0} 个问题": "{0} issues",
  "{0} 之下": "under {0}",
  "{0} 份": "{0}",
  "{0} 份出站报文超过约定时限仍未收到伙伴回复": "{0} outbound messages have no partner reply past the agreed time limit",
  "{0} 份报文全部合规": "All {0} messages compliant",
  "{0} 位": "{0} bits",
  "{0} 哈希链完整：已校验 {1} 条记录": "{0} Hash chain intact: {1} records verified",
  "{0} 天后转入归档": "Archived after {0} days",
  "{0} 张伙伴证书已过期，AS2 验签或加密将失败": "{0} partner certificates have expired; AS2 signature verification or encryption will fail",
  "{0} 提交于{1}": "{0} submitted at {1}",
  "{0} 条失败": "{0} failed",
  "{0} 条未转入，下次自动重试": "{0} not archived; retried automatically next time",
  "{0} 条预警": "{0} alerts",
  "{0} 次采用": "Used {0} times",
  "{0} 生效配置": "{0} effective configuration",
  "{0} 种": "{0} types",
  "{0} 表": "{0} table",
  "{0} 表格": "{0} table",
  "{0} 运行记录": "{0} run log",
  "{0}/{1} 个关键词命中来源节点": "{0}/{1} keywords match the source node",
  "{0}个端口": "{0} ports",
  "{0}为伙伴启用一条测试约定，再回来模拟。": "{0} and enable a test agreement for a partner, then come back to simulate.",
  "{0}已复制": "{0} copied",
  "{0}模型": "{0} model",
  "{0}登记伙伴、维护": "{0} register the partner and maintain its",
  "{0}相比": "Compared with {0}",
  "{0}转换出的标准业务数据，即业务流程将收到的内容": "Canonical business data produced by {0}, i.e. what the business flow will receive",
  "{0}（{1} → {2}，单号 {3}）": "{0} ({1} → {2}, ref {3})",
  "{0}（{1}）": "{0} ({1})",
  "{0}（{1}） · 测试区间{2} {3} 至 {4} · 生成于 {5}": "{0} ({1}) · test period{2} {3} to {4} · generated {5}",
  "{0}（变更）": "{0} (changed)",
  "{0}（已取消）": "{0} (cancelled)",
  "{0}（预置）": "{0} (preset)",
  "· {0} 失败": "· {0} failed",
  "· 可实时处理": " · processing in real time",
  "· 生成于": "· generated",
  "。保存端口后生效。": ". Takes effect after the port is saved.",
  "。只影响当前草稿版本，发布后才生效；已上线的交换约定仍用原版本，确认后再切换。": ". Only the current draft is affected and takes effect after publishing; live agreements keep the original version until switched.",
  "。已启用的约定会立即以新版本重新发布；不匹配的约定保持原样。": ". Enabled agreements are republished with the new version immediately; agreements that do not match stay unchanged.",
  "「{0}」是列表，请先把一个可重复记录拖到它上面建立循环": "\"{0}\" is a list; first drag a repeating record onto it to create a loop",
  "一、结论": "1. Conclusion",
  "一个伙伴可以有多个通道（如 AS2 主通道 + SFTP 备用）。通道只填伙伴侧地址与本方覆盖项，其余沿用「本方协议」默认值；保存后生成新配置版本，审核通过并发布后生效。": "A partner can have several channels (e.g. AS2 primary + SFTP backup). A channel holds only the partner side and our overrides; everything else comes from \"Local profiles\". Saving creates a new configuration version that takes effect after review and publishing.",
  "一句话说清是什么问题": "State the problem in one sentence",
  "一条交换约定 = 与一个伙伴、就一种报文、一个方向的约定": "One exchange agreement = one partner, one message type, one direction",
  "一键自动排版": "One-click layout",
  "三、交换约定": "3. Exchange agreements",
  "上传客户端证书 (.p12 / .pfx)": "Upload client certificate (.p12 / .pfx)",
  "上传文件": "Upload file",
  "上次发送时间": "Last sent",
  "上次审核被退回（{0}）": "Last review rejected ({0})",
  "上线": "Go live",
  "上线中": "Onboarding",
  "上线生产": "Go live",
  "上线进度": "Onboarding progress",
  "上线进度暂不可用": "Onboarding progress unavailable",
  "上线阶段": "Onboarding stage",
  "下一步：{0}": "Next: {0}",
  "下载原始内容 ({0})": "Download original ({0})",
  "下载私钥证书": "Download private key certificate",
  "下载证书申请": "Download certificate request",
  "不交付业务系统": "not delivered to the business system",
  "不使用客户端证书": "No client certificate",
  "不压缩": "No compression",
  "不发送给伙伴": "not sent to the partner",
  "不可切换": "Cannot switch",
  "不属于": "not in",
  "不投递（仅转换）": "Do not deliver (map only)",
  "不推算": "Do not derive",
  "不是有效的 JSON": "Not valid JSON",
  "不等于": "not equal",
  "不能包含重复的标识体系": "Identifier schemes must not repeat",
  "不能小于最少出现次数": "Cannot be less than min occurrences",
  "不要求": "Not required",
  "不选：测试报文只做解析、校验与转换，不投递任何业务系统。需要端到端联调时，选一个投递到业务系统测试环境（UAT）的流程。": "None: test messages are parsed, validated and mapped but not delivered to any business system. For end-to-end testing, choose a flow that delivers to the business system's test environment (UAT).",
  "不需要": "Not needed",
  "与": "and",
  "与业务系统确认接口性能；必要时调整推送超时与重试。": "Check API performance with the business system; adjust push timeout and retries if needed.",
  "与伙伴收发文件的通道": "Channels for exchanging files with the partner",
  "与基准一致": "Same as baseline",
  "与基准对比": "Compare with baseline",
  "与基准对比 {0}": "Compare with baseline {0}",
  "与基准有 {0} 处不同": "{0} differences from baseline",
  "与当前草稿相比：": "Compared with the current draft:",
  "与最新版本一致": "Same as latest version",
  "与每个伙伴收发哪些报文、用什么版本与映射、走什么端口": "Which messages are exchanged with each partner, with which version, mapping and port",
  "与该伙伴收发的每种报文一条约定：报文定义、映射版本、业务流程、协议端口与回执要求。": "One agreement per message exchanged with this partner: message definition, mapping version, business flow, protocol port and acknowledgements.",
  "与该定义匹配的映射": "Mappings that match this definition",
  "专线检查线路与 IP 白名单；公网检查 DNS 与 TLS 证书有效期；也可能是伙伴服务器维护。": "For private lines check the line and IP whitelist; over the internet check DNS and TLS certificate validity; the partner server may also be under maintenance.",
  "业务中断风险": "Outage risk",
  "业务交付": "Deliver to business",
  "业务侧去向": "Business-side destination",
  "业务侧来源": "Business-side source",
  "业务单号": "Business reference",
  "业务单号 {0}": "Reference {0}",
  "业务单号取自": "Business reference taken from",
  "业务回执": "Business acknowledgement",
  "业务报文": "Business messages",
  "业务提交": "Business submission",
  "业务数据": "Business data",
  "业务数据 JSON": "Business data JSON",
  "业务数据不是合法的 JSON 数组": "Business data is not a valid JSON array",
  "业务数据应是一个非空数组，每个元素是一票业务单据": "Business data must be a non-empty array, one business document per element",
  "业务模型": "Business model",
  "业务流程": "Business flow",
  "业务流程 · 所有伙伴共用": "Business flow · shared by all partners",
  "业务流程接收所有伙伴按交换约定转换好的标准业务数据，不属于某个伙伴；启用后在交换约定里选择它": "A business flow receives canonical business data from all partners converted under their agreements and belongs to no single partner; after enabling, select it in exchange agreements",
  "业务环节": "Business stage",
  "业务系统发出业务事件": "Business system sends a business event",
  "业务系统只需把业务事实（如订舱确认）连同伙伴编码发到这一个地址；发给哪个伙伴、用什么报文与版本、走什么协议都由交换约定决定，新增伙伴无需改业务系统。": "A business system only sends the business fact (e.g. a booking confirmation) with the partner code to this one address; which partner, message, version and protocol are decided by exchange agreements, so adding a partner needs no change in the business system.",
  "业务系统批量推送时调用{0}": "Business systems call {0} for batch pushes",
  "业务系统接入": "Business system access",
  "业务系统携带接入密钥提交业务数据，按提交编号去重": "Business systems submit business data with the access key; de-duplicated by submission ID",
  "业务系统连接": "System Connections",
  "业务系统连接用于管理内部业务系统（ERP、TMS、WMS、数据库等）的地址与认证凭据，供工作流节点共享复用。与外部贸易伙伴的通信通道请在「接入管理」中配置。": "System connections manage addresses and credentials for internal systems (ERP, TMS, WMS, databases) shared across workflow nodes. External partner transport channels are configured under Access Management.",
  "业务系统需改用新密钥": "The business system must switch to the new key",
  "业务系统（FTP / SFTP 连接）": "Business system (FTP / SFTP connection)",
  "业务负责人": "Business owner",
  "业务过程": "Business process",
  "两个版本结构一致": "The two versions have the same structure",
  "中": "Medium",
  "中国（UTC+8）": "China (UTC+8)",
  "中文名称": "Chinese name",
  "临时订舱": "Provisional booking",
  "为什么不需要这个字段，例如：业务系统不使用航线名称": "Why this field is not needed, e.g. the business system does not use the route name",
  "为每种报文新建一条": "Create one agreement per message in",
  "为空": "is empty",
  "主体协议端口": "Party protocol port",
  "主机": "Host",
  "主机与端口": "Host and port",
  "主机密钥": "Host key",
  "主机密钥指纹": "Host key fingerprint",
  "主要交互方": "Main counterparties",
  "也可以在报文中心打开任意一条报文，点「诊断原文」直接载入。要把文件真的交给平台处理，请用": "You can also open any message in the message center and click \"Diagnose original\" to load it here. To have the platform actually process a file, use",
  "二、上线检查": "2. Onboarding checks",
  "五、签认": "5. Sign-off",
  "交互笔数": "Exchanges",
  "交付": "is delivered as usual",
  "交付业务方": "Deliver to business",
  "交付的业务数据": "Delivered business data",
  "交换": "Interchange",
  "交换 {0}": "Interchange {0}",
  "交换与回执": "Interchange and acknowledgements",
  "交换中没有报文": "No messages in the interchange",
  "交换引擎不执行此类节点，请从画布上删除。": "The exchange engine does not run this kind of node; delete it from the canvas.",
  "交换引擎内置执行的航运实施指南（MIG），可直接在交换约定中选用；不在此编辑或发布。": "Shipping implementation guides (MIGs) built into the exchange engine, selectable directly in exchange agreements; not edited or published here.",
  "交换引擎堆内存使用率超过即告警": "Alert when the exchange engine's heap usage exceeds this",
  "交换引擎暂不可达，稍后刷新": "Exchange engine unreachable; refresh later",
  "交换控制号": "Interchange control reference",
  "交换文件": "Exchange files",
  "交换约定": "Exchange agreements",
  "交换记录": "Interchanges",
  "交易伙伴": "Trading partners",
  "交易伙伴信息已更新": "Trading partner updated",
  "交易伙伴（协议端口）": "Trading partner (protocol port)",
  "人大金仓": "Kingbase",
  "人大金仓 KingbaseES": "KingbaseES relational database",
  "仅原始报文": "Original messages only",
  "仅当条件成立时取值": "Take the value only when the condition holds",
  "仅支持大写字母、数字和下划线": "Only upper-case letters, digits and underscores",
  "仅显示有效的 RSA 私钥证书；私钥密码由证书材料安全保存。": "Only valid RSA private key certificates are shown; the key password is kept with the certificate material.",
  "仅未认领": "Unclaimed only",
  "仅目录": "Directory only",
  "今日": "Today",
  "今日新增": "New today",
  "仍然离开": "Leave anyway",
  "从左侧拖一个源字段到这一行，或在这里设置取值": "Drag a source field from the left onto this row, or set the value here",
  "从平台收件目录或 HTTP 接收地址领取伙伴报文，按报文头识别伙伴与报文类型": "Collect partner messages from the platform inbox or HTTP receiving address; identify partner and message type from the header",
  "从报文记录选择": "Pick from message records",
  "从模板开始": "Start from template",
  "从空白画布自由搭建流程": "Build a flow freely on a blank canvas",
  "从预置业务模板快速搭建，或自由添加节点编排链路。": "Quickly build from presets, or freely add nodes to assemble the flow.",
  "代码": "Code",
  "代码 (1-35 字符)": "Code (1–35 chars)",
  "令牌地址 (Token URL)": "Token URL",
  "令牌地址必须以 http:// 或 https:// 开头": "Token URL must start with http:// or https://",
  "令牌（Bearer）": "Token (Bearer)",
  "以 {0}{1}为基础复制出一个草稿版本，在草稿里调整结构；发布前不影响任何交换约定。": "Copy {0}{1} into a draft version and adjust the structure there; no exchange agreement is affected until it is published.",
  "以下为已发布（v{0}）的配置，修改通道后需保存才会生效": "Below is the published configuration (v{0}); channel changes take effect only after saving",
  "以下约定尚无通过的测试报文：{0}。": "These agreements have no passed test message yet: {0}.",
  "任务": "Job",
  "企业列表加载失败，请返回工作台后重试。": "Failed to load organizations; return to the workbench and try again.",
  "企业微信、钉钉、飞书群机器人地址会自动按其消息格式发送；钉钉/飞书开启加签时在地址后加 #secret=密钥（密钥不会随请求发出）": "WeCom, DingTalk and Feishu group bot URLs are sent in their own message formats; for DingTalk/Feishu signing add #secret=<key> after the URL (the key is never sent)",
  "伙伴": "Partner",
  "伙伴 AS2 接收地址": "Partner AS2 URL",
  "伙伴 AS2 标识": "Partner AS2 ID",
  "伙伴 → 本方（入站）或 本方 → 伙伴（出站）的报文信封标识": "Envelope IDs partner → us (inbound) or us → partner (outbound)",
  "伙伴、报文类型、定义": "Partner, message type, definition",
  "伙伴不存在或无权查看": "Partner not found or no permission",
  "伙伴与方向": "Partner and direction",
  "伙伴业务数据": "Partner business data",
  "伙伴从此目录取件；文件写完后才出现正式文件名": "Partners collect files from this folder; a file gets its final name only after it is fully written",
  "伙伴代码": "Partner code",
  "伙伴代码 (1-35 字符)": "Partner code (1–35 chars)",
  "伙伴以 HTTPS POST 推送报文到本方地址，携带在其传输通道里生成的推送令牌。": "Partners push messages to our address by HTTPS POST with the push token generated in their channel.",
  "伙伴使用的代码": "Code used by the partner",
  "伙伴侧发送": "Partner-side send",
  "伙伴侧接收": "Partner-side receive",
  "伙伴列表": "Partners",
  "伙伴列表 · {0}": "Partners · {0}",
  "伙伴加密证书": "Partner encryption certificate",
  "伙伴发来": "From partner",
  "伙伴发来报文": "Partner sends a message",
  "伙伴发来的原始报文": "The original message from the partner",
  "伙伴名称": "Partner name",
  "伙伴向我方推送": "Partner pushes to us",
  "伙伴回复语法回执（CONTRL）": "Reply as partner with syntax acknowledgement (CONTRL)",
  "伙伴回复超时": "Partner reply overdue",
  "伙伴处理周期本就较长时，在交换约定中调整回复时限，避免误报。": "If the partner normally takes longer, adjust the reply time limit in the agreement to avoid false alerts.",
  "伙伴外部码值": "Partner external codes",
  "伙伴外部码值（可选，一个伙伴一个）": "Partner external codes (optional, one per partner)",
  "伙伴实际使用的报文实施指南：标准、版本、报文类型及其结构与校验规则": "The implementation guide the partner actually uses: standard, version, message type, structure and validation rules",
  "伙伴已登记，接下来按上线步骤配置通道与交换约定": "Partner registered; next, configure channels and exchange agreements following the onboarding steps",
  "伙伴技术": "Partner technical",
  "伙伴把 AS2 报文发到本方接收地址，用本方公钥加密、验本方签名；MDN 同步或发到异步 MDN 地址。": "Partners send AS2 messages to our receiving URL, encrypted with our public key and verified with our signature; MDN is synchronous or sent to the async MDN URL.",
  "伙伴拒收报文": "Partner rejected a message",
  "伙伴接收地址（我方发送）": "Partner receiving URL (we send)",
  "伙伴推送令牌（只显示这一次）": "Partner push token (shown only once)",
  "伙伴推送时用 Bearer 令牌认证；平台只保存令牌的 SHA-256，令牌只在生成时显示一次": "The partner authenticates pushes with a Bearer token; the platform keeps only its SHA-256 and shows the token once when generated",
  "伙伴提供的 SSH 主机密钥 SHA-256 指纹；填写后只连接该服务器，防止中间人": "SHA-256 fingerprint of the partner's SSH host key; when set, only that server is trusted (prevents man-in-the-middle)",
  "伙伴放件目录（我方来取）": "Partner drop folder (we collect)",
  "伙伴数据有误：按约定已回 CONTRL 拒绝，请伙伴按 MIG 修正后重发。": "Partner data is wrong: CONTRL rejection was sent as agreed; ask the partner to fix it per the MIG and resend.",
  "伙伴服务器地址": "Partner server address",
  "伙伴服务器维护或网络中断时，恢复后在报文详情「补发」（保留原控制号，伙伴可据此去重）。": "If the partner server was under maintenance or the network was down, \"Resend\" from the message details after recovery (the original control reference is kept so the partner can de-duplicate).",
  "伙伴标识{0}": "Partner ID{0}",
  "伙伴码值已保存": "Partner code saved",
  "伙伴签名证书（验签）": "Partner signing certificate (verify)",
  "伙伴类型": "Partner type",
  "伙伴经 SFTP 或共享目录把文件放入此目录；引擎按报文头的报文类型、发送方、接收方匹配本工作流": "Partners drop files here over SFTP or a shared folder; the engine matches this workflow by message type, sender and receiver in the header",
  "伙伴给我方的令牌": "Token issued by the partner",
  "伙伴编码": "Partner code",
  "伙伴证书": "Partner certificates",
  "伙伴证书：{0} 张已过期，{1} 张 30 天内到期": "Partner certificates: {0} expired, {1} expiring within 30 days",
  "伙伴需改用新密钥": "The partner must switch to the new key",
  "传输": "Transport",
  "传输安全（FTPS）": "Transport security (FTPS)",
  "传输异常": "Transport issue",
  "传输通道": "Channels",
  "位置": "Location",
  "位置：": "Position:",
  "低": "Low",
  "体系": "Scheme",
  "作为业务系统发送": "Send as business system",
  "作为伙伴回复": "Reply as partner",
  "作为伙伴投递": "Deliver as partner",
  "使用本方默认": "Use our default",
  "使用缺省值": "Use default",
  "使用该码表的报文结构节点": "Structure nodes using this code list",
  "例如 IFTMBF D.99B": "e.g. IFTMBF D.99B",
  "例如 PARTNER_OFFLINE": "e.g. PARTNER_OFFLINE",
  "例如发出订舱申请 IFTMBF 后期望收到订舱确认 IFTMBC；超时未回复会进入预警": "e.g. after sending a booking request IFTMBF, expect a booking confirmation IFTMBC; no reply in time raises an alert",
  "例如：*.edi": "e.g. *.edi",
  "例如：50000-50100。": "e.g. 50000-50100.",
  "例如：AS2:MYCOMPANY": "e.g. AS2:MYCOMPANY",
  "例如：AWS-AS2": "e.g. AWS-AS2",
  "例如：HMM_KR": "e.g. HMM_KR",
  "例如：IFTMIN": "e.g. IFTMIN",
  "例如：O0013000DEMO": "e.g. O0013000DEMO",
  "例如：local-key://...": "e.g. local-key://...",
  "例如：read write，可选": "e.g. read write, optional",
  "例如：上海货代 · IFTMBF 订舱申请": "e.g. Shanghai forwarder · IFTMBF booking request",
  "例如：中远 0923 订舱": "e.g. COSCO 0923 booking",
  "例如：中远订舱 → 订舱模型": "e.g. COSCO booking → booking model",
  "例如：本方 {0}配置": "e.g. Our {0} settings",
  "例如：标准入站订舱处理模板": "e.g. Standard inbound booking template",
  "例如：现代商船 HMM (Hyundai Merchant Marine)": "e.g. HMM (Hyundai Merchant Marine)",
  "例如：船公司订舱单入站": "e.g. Carrier booking inbound",
  "例如：订舱库（生产）": "e.g. Booking DB (production)",
  "便于搜索，如错误代码、伙伴、报文类型": "For search, e.g. error code, partner, message type",
  "保存": "Save",
  "保存中…": "Saving…",
  "保存冲突，需要重新加载": "Save conflict; reload needed",
  "保存失败": "Save failed",
  "保存失败，稍后重试": "Save failed, try again later",
  "保存失败，请稍后重试": "Save failed, please try again later",
  "保存并启用": "Save and enable",
  "保存并重新发布": "Save and republish",
  "保存所选节点为模板": "Save selected nodes as template",
  "保存标识": "Save IDs",
  "保存模板": "Save template",
  "保存草稿": "Save draft",
  "保存连接时必须核对并填入对方主机密钥指纹，测试连接可获取服务器指纹。": "Verify and enter the host key fingerprint before saving; connectivity test returns the server fingerprint.",
  "保留": "Kept",
  "保留原值": "Keep value",
  "保留策略": "Retention",
  "信任此指纹": "Trust this fingerprint",
  "信任该 CA 签发的服务器证书（替代关闭校验）": "Trust server certificates issued by this CA (alternative to disabling verification)",
  "信封": "Envelope",
  "信封标识": "Envelope IDs",
  "修改": "Modify",
  "修改 {0}": "Changed {0}",
  "修改了连接地址，服务器拒绝沿用已存密码，请重新输入。": "Connection address was changed; stored password cannot be reused, please re-enter.",
  "修改了连接地址，服务器拒绝沿用已存密钥，请重新输入。": "Connection address was changed; stored secret cannot be reused, please re-enter.",
  "修改了连接地址，服务器拒绝沿用已存私钥，请重新输入。": "Connection address was changed; stored private key cannot be reused, please re-enter.",
  "修改连接地址后必须重新输入凭据": "Credentials must be re-entered after modifying connection address",
  "修改连接地址后必须重新输入密码": "Password must be re-entered after modifying connection address",
  "修改连接地址后必须重新输入私钥": "Private key must be re-entered after modifying connection address",
  "修改通道、标识等配置会生成新版本，审核通过并发布后生效": "Changes to channels, IDs and other settings create a new version that takes effect after review and publishing",
  "修正并发布映射后，对该报文执行「重处理」，原记录保留，生成新的处理尝试。": "After fixing and publishing the mapping, reprocess the message; the original record is kept and a new attempt is created.",
  "修正映射或业务数据后重新发送（新交换控制号）；与伙伴 MIG 理解不一致时先对齐实施指南。": "Fix the mapping or business data and send again (new control reference); align the implementation guide first if our reading of the partner MIG differs.",
  "值": "Value",
  "停用": "Disable",
  "停用「{0}」？": "Disable \"{0}\"?",
  "停用伙伴": "Disable partner",
  "停用后该伙伴的这种报文将不再被收发。": "After disabling, this message type is no longer exchanged with the partner.",
  "停用后该工作流将不再接收和处理新的报文。": "After disabling, the workflow no longer receives or processes new messages.",
  "停用该约定？": "Disable this agreement?",
  "健康": "Health",
  "允许的 IP/CIDR": "Allowed IP / CIDR",
  "允许的来源 IP": "Allowed source IPs",
  "元素编码": "Element code",
  "先到": "First go to",
  "先添加至少一个传输通道，再提交审核": "Add at least one channel before submitting for review",
  "先登记伙伴是谁、在信封里用什么代码；通道、证书与交换约定在伙伴概览里按上线步骤逐项配置，通道信息可以等伙伴提供后再补。": "First register who the partner is and which codes it uses in envelopes; channels, certificates and agreements are configured step by step in the partner overview, and channel details can be added once the partner provides them.",
  "先选择交易伙伴": "Select a trading partner first",
  "先选择伙伴": "Select a partner first",
  "先选择报文定义": "Select a message definition first",
  "入站": "Inbound",
  "入站 · 拆分": "Inbound · split",
  "入站多报文交换自动拆分逐份处理；出站多票业务数据合并为一个交换发送": "Inbound multi-message interchanges are split and processed one by one; outbound documents are combined into one interchange",
  "入站拆分": "Inbound split",
  "入站流程": "Inbound flows",
  "入站（从伙伴接收数据）": "Inbound (receive from partners)",
  "入站（伙伴 → 我方）": "Inbound (partner → us)",
  "入站：伙伴发给我方": "Inbound: partner sends to us",
  "全流程记录该交易伙伴的配置修改、回执调整与状态流转历史（操作记录不可篡改）。": "Complete, tamper-proof history of this partner's configuration changes, acknowledgement settings and status changes.",
  "全部": "All",
  "全部 {0}": "All {0}",
  "全部伙伴": "All partners",
  "全部工作流": "All workflows",
  "全部方向": "All directions",
  "全部检查通过": "All checks passed",
  "全部状态": "All statuses",
  "全部环境": "All environments",
  "全部类型": "All types",
  "公共接收基础地址": "Public receiving base URL",
  "公网只能使用 FTPS；明文 FTP 仅限专线": "Only FTPS is allowed over the internet; plain FTP only on private lines",
  "公网或专线可达地址": "Address reachable over the internet or private line",
  "公钥": "Public key",
  "公钥类型": "Public key type",
  "公钥证书": "Public certificate",
  "公钥证书下载失败": "Failed to download public certificate",
  "公钥证书会展示有效期；私钥材料不包含 X.509 有效期信息。交易伙伴和通道通过证书引用使用这些材料。": "Public certificates show their validity; private key material has no X.509 validity. Partners and channels use this material through certificate references.",
  "共 {0} 份测试报文，通过 {1} 份": "{0} test messages, {1} passed",
  "共 {0} 份测试报文，通过 {1} 份。": "{0} test messages, {1} passed. ",
  "共 {0} 份测试报文，通过 {1} 份，未通过 {2} 份。": "{0} test messages, {1} passed, {2} not passed. ",
  "共 {0} 条": "{0} in total",
  "共 {0} 条预警": "{0} alerts",
  "共 {0} 条，已导出前 {1} 条；请缩小时间范围后分批导出": "{0} in total; exported the first {1}. Narrow the time range and export in batches",
  "共 {0} 次": "{0} in total",
  "共 {0} 次处理尝试": "{0} processing attempts",
  "共 {0} 次尝试": "{0} attempts",
  "共 {0} 笔记录": "{0} records",
  "关联码表": "Code lists",
  "关键词（可选）": "Keywords (optional)",
  "关闭后允许不信任的自签名证书": "Allow untrusted or self-signed certificates when disabled",
  "关闭工单": "Work orders closed",
  "关闭面板": "Close panel",
  "其他": "Other",
  "兼容 Greenplum、Highgo、PolarDB PostgreSQL": "Compatible with Greenplum, Highgo, and PolarDB PostgreSQL",
  "兼容 TiDB、OceanBase MySQL 模式": "Compatible with TiDB and OceanBase MySQL mode",
  "兼容的后续节点": "Compatible next nodes",
  "内存使用上限": "Memory usage limit",
  "内存：检查报文量高峰与批量合并的大小，必要时为交换引擎扩容。": "Memory: check message peaks and batch sizes; scale up the exchange engine if needed.",
  "内容 SHA-256": "Content SHA-256",
  "内部系统": "Internal system",
  "内部系统的接收方式在工作流的「业务流程」里配置一次，所有伙伴共用。": "How internal systems receive data is configured once in Workflow → Business flows, shared by all partners.",
  "写入数据库": "Write to database",
  "写库节点的表名按此限定；留空使用默认模式": "Table names for db write nodes are qualified by this schema; leave blank for default schema",
  "写明需要修改什么，如：SG3 最多出现次数应为 9": "State what needs to change, e.g. SG3 max occurrences should be 9",
  "出现次数超限": "Too many occurrences",
  "出现规则": "Occurrence",
  "出站": "Outbound",
  "出站 · 合并": "Outbound · combined",
  "出站交换 UNB 中的 S001；不选为 UNOC": "S001 in the UNB of outbound interchanges; UNOC if not set",
  "出站合并": "Outbound combined",
  "出站流程": "Outbound flows",
  "出站（向伙伴发送数据）": "Outbound (send to partners)",
  "出站（我方 → 伙伴）": "Outbound (us → partner)",
  "出站：我方发给伙伴": "Outbound: we send to partner",
  "出错": "Error",
  "分发": "Dispatch",
  "分支 {0} {1}": "Branch {0} {1}",
  "分类": "Category",
  "分钟": "min",
  "切换": "Switch",
  "切换为生产？": "Switch to production?",
  "切换企业": "Switch organization",
  "切换到此尝试 ({0})": "Switch to this attempt ({0})",
  "切换后只接受不带测试标志的交换，出站也不再打测试标志。": "After switching, only interchanges without the test flag are accepted and outbound ones are no longer flagged as test.",
  "切换模型": "Switch model",
  "切换模型 — {0}": "Switch model — {0}",
  "列「{0}」{1} → {2}": "Column \"{0}\" {1} → {2}",
  "列「{0}」类型 {1} → {2}": "Column \"{0}\" type {1} → {2}",
  "列表": "List",
  "列表目标需要拖入一个可重复记录，生成循环": "A list target needs a repeating record dragged onto it to create a loop",
  "创建/加入企业": "Create / join organization",
  "创建工作流": "Create workflow",
  "创建并编辑": "Create and edit",
  "创建草稿": "Create draft",
  "创建证书": "Create certificate",
  "删除": "Delete",
  "删除 {0}": "Removed {0}",
  "删除 {0}？": "Delete {0}?",
  "删除「{0}」？": "Delete \"{0}\"?",
  "删除企业": "Delete organization",
  "删除列": "Columns removed",
  "删除列「{0}」（原为 {1}）": "Column \"{0}\" removed (was {1})",
  "删除只移除租户材料绑定，不会删除历史报文记录。": "Deleting only removes the tenant's binding to the material; message history is kept.",
  "删除后将移除该节点及所有连线": "The node and all its connections will be removed",
  "删除后无法恢复。": "This cannot be undone.",
  "删除失败": "Delete failed",
  "删除循环会同时删除其中的全部规则": "Deleting the loop deletes all rules inside it",
  "删除未引用证书材料？": "Delete unreferenced certificate material?",
  "删除模板": "Delete template",
  "删除模板失败": "Failed to delete template",
  "删除节点": "Delete node",
  "删除该约定？": "Delete this agreement?",
  "删除这个样例？": "Delete this sample?",
  "删除这条规则？": "Delete this rule?",
  "删除连接": "Delete connection",
  "判定不可达的连续失败次数": "Consecutive failures before unreachable",
  "判定条件": "Condition",
  "到接入管理对伙伴端口做连通性测试，核对地址、账号、证书是否过期。": "Test the partner port under Access management; check address, account and certificate expiry.",
  "到映射设计器新建或调整映射": "Create or adjust mappings in the mapping designer",
  "刷新": "Refresh",
  "刷新数据": "Refresh",
  "刷新表结构": "Refresh table structure",
  "前往交易伙伴补充": "Complete it under Trading partners",
  "前往本方协议设置": "Go to local profile settings",
  "剩余 {0} 天": "{0} days left",
  "剩余 {0} 天 (临期)": "{0} days left (expiring)",
  "剩余 {0} 天 (紧急)": "{0} days left (urgent)",
  "剩余天数": "Days left",
  "功能": "Function",
  "加密": "Encryption",
  "加密 / 密钥交换（X25519）": "Encryption / key exchange (X25519)",
  "加密方式": "Encryption",
  "加密算法": "Encryption algorithm",
  "加密证书（伙伴用它加密）": "Encryption certificate (partners encrypt with it)",
  "加载模型场景配置失败，请确认应用后端已启动且可访问 AI 服务": "Failed to load model scenarios; check the application backend is running and can reach the AI service",
  "包含当前伙伴使用的签名、加密与 TLS 身份凭据。": "Signing, encryption and TLS credentials used with this partner.",
  "包含文件名关键词": "File name contains",
  "匹配的回执类型": "Matching acknowledgement types",
  "匹配的错误代码": "Matching error codes",
  "区分大小写，与伙伴 AS2-From 一致": "Case-sensitive; must match the partner's AS2-From",
  "协议": "Protocol",
  "协议端口": "Protocol port",
  "协议：{0}；端口配置在主体审核与发布后生效。": "Protocol: {0}; port settings take effect after the party is reviewed and published.",
  "单份报文从接收到完成超过该时长即告警": "Alert when a message takes longer than this from receipt to completion",
  "单号": "Reference",
  "单号 / 箱号": "Reference / container",
  "单号追溯": "Reference trace",
  "单据交互概览": "Document overview",
  "单据异常状态": "Exception status",
  "单据最新一次尝试状态为失败（FAILED），尚未重处理成功，可能导致业务履约中断，请及时排查与重处理。": "The document's latest attempt FAILED and has not been reprocessed successfully; this may disrupt fulfilment. Investigate and reprocess promptly.",
  "单次报文上限": "Max message size",
  "占用": "used",
  "即将到期": "Expiring soon",
  "历史尝试曾发送，经补发后成功": "An earlier attempt was sent; succeeded after resending",
  "历史尝试曾处理失败，最新尝试已成功": "An earlier attempt failed; the latest attempt succeeded",
  "压缩": "Compression",
  "压缩并加密后的占用": "Size after compression and encryption",
  "原因": "Reason",
  "原因: {0}": "Reason: {0}",
  "原因：{0}": "Reason: {0}",
  "原始": "Original",
  "原始报文": "Original message",
  "原始报文下载失败": "Failed to download the original message",
  "原始报文与处理数据全量留存：热期在数据库，过期加密转入归档存储，查询时按需读回": "All original messages and processing data are kept: recent ones in the database, older ones encrypted in archive storage and read back on demand",
  "原始报文编号": "Original message ID",
  "原始文件": "Original file",
  "原报文编号": "Original message ID",
  "去向 / 期望回复": "Destination / expected reply",
  "去测试联调": "Go to testing",
  "参数名": "Parameter name",
  "参考": "Reference",
  "参考号": "Reference",
  "双向 TLS 客户端证书": "Mutual TLS client certificate",
  "发": "Out",
  "发件目录": "Outbox folder",
  "发出": "Sent",
  "发出的": "Sent",
  "发布": "Publish",
  "发布 v{0}": "Publish v{0}",
  "发布到交换引擎": "Publish to exchange engine",
  "发布到交换引擎失败": "Failed to publish to the exchange engine",
  "发布后可在交换约定中选用；已上线的约定仍使用原来的报文定义版本，确认后在约定里切换。": "After publishing it can be selected in exchange agreements; live agreements keep their definition version until switched there.",
  "发布命令已提交，运行状态等待网关确认": "Publish submitted; waiting for the gateway to confirm",
  "发布失败": "Publish failed",
  "发布新版本": "Publish new version",
  "发布检查": "Publish check",
  "发布检查未通过": "Publish check failed",
  "发布检查要求这个字段被映射，或标记为不需要并写明原因": "Publishing requires this field to be mapped, or marked as not needed with a reason",
  "发布配置": "Publish configuration",
  "发现 {0} 个问题": "{0} issues found",
  "发给伙伴": "To partner",
  "发送": "Send",
  "发送主体": "Sending party",
  "发送到": "Send to",
  "发送失败": "Sending failed",
  "发送方": "Sender",
  "发送方 → 接收方": "Sender → receiver",
  "发：加密": "Send: encrypted",
  "发：签名": "Send: signed",
  "取件间隔（秒）": "Collection interval (s)",
  "取值为空时使用": "Used when the value is empty",
  "取值方式": "Value source",
  "取值：": "Value:",
  "取消": "Cancel",
  "受影响协议": "Affected protocols",
  "受理提交": "Accept submission",
  "变化": "Change",
  "变更": "Change",
  "变更待审核": "Changes pending review",
  "另存为工作流模板": "Save as workflow template",
  "另存为模板": "Save as template",
  "另存为模板失败": "Failed to save as template",
  "只列出与「{0}」节点的 {1} 配套的映射": "Only mappings that go with {1} of the \"{0}\" node are listed",
  "只列出我方发出、仍在等待伙伴 CONTRL的测试交换；生产交换的回执只能来自伙伴本身。不回复即模拟超时：到约定的回复时限后进入「伙伴回复超时」预警。": "Lists only test interchanges we sent that still await the partner's CONTRL; acknowledgements for production interchanges can only come from the partner. Not replying simulates a timeout: after the agreed limit a \"Partner reply overdue\" alert is raised.",
  "只列出源和目标相同、已发布的映射，复制其最新版本": "Only published mappings with the same source and target; the latest version is copied",
  "只填需要覆盖本方协议默认的字段；表单未覆盖的配置项在这里编辑。": "Only fields that override the local profile defaults; settings the form does not cover are edited here.",
  "只处理满足条件的记录": "Only records meeting the condition",
  "只影响当前草稿版本。": "Only the current draft version is affected.",
  "只有报文（UNH…UNT），没有交换信封": "Only a message (UNH…UNT), no interchange envelope",
  "只看未解决失败": "Unresolved failures only",
  "只读": "Read-only",
  "可以启用": "Ready to enable",
  "可提前配置下一版本解密证书，供证书轮换期间使用。": "Configure the next decryption certificate in advance for use during rotation.",
  "可用变量：value（当前值）、it（当前记录）、root（整个源）；保存时由引擎校验。": "Available variables: value (current value), it (current record), root (whole source); checked by the engine on save.",
  "可选": "Optional",
  "可选填关联报文编号": "Related message ID (optional)",
  "可选未映射": "Optional, unmapped",
  "可选；只选择有效的本方 TLS 私钥证书。": "Optional; only valid local TLS private key certificates.",
  "各分支独立投递": "Branches deliver independently",
  "合并为一个交换发送": "Send as one interchange",
  "合并发送": "Batch send",
  "合规": "Compliant",
  "合规校验": "Validate",
  "合规校验不通过 {0} 次": "Validation failed {0} times",
  "合规校验不通过时": "When validation fails",
  "同一 submissionId重复提交返回第一次的结果；返回中含报文编号、状态、文件名与校验问题": "Repeating a submissionId returns the first result; the response includes message ID, status, file name and validation issues",
  "同一去重键在静默窗口内自动折叠，避免高频刷屏；该预警已累计触发 {0} 次。": "Alerts with the same de-duplication key are folded within the quiet window to avoid flooding; this alert has fired {0} times.",
  "同时创建配对的 X25519 密钥交换材料": "Also create matching X25519 key exchange material",
  "同步": "Synchronous",
  "名称": "Name",
  "名称如 X-Client-Id": "Header name, e.g. X-Client-Id",
  "名称或编码": "Name or code",
  "向量": "Embedding",
  "向量 Embedding": "Embedding",
  "否": "No",
  "含测试交换": "Include test interchanges",
  "启用": "Enable",
  "启用伙伴": "Enable partner",
  "启用前请先完善工作流（存在 {0} 个未解决问题）": "Complete the workflow before enabling ({0} unresolved problems)",
  "启用前请先完善工作流：存在 {0} 个问题": "Complete the workflow before enabling: {0} problems",
  "启用协议": "Enabled protocols",
  "启用后显示引擎的收发目录": "The engine's exchange folders are shown after enabling",
  "启用后生成接入地址与接入密钥": "Access URL and key are generated after enabling",
  "启用时的最新版本": "Latest version at enable time",
  "周报（上周）": "Weekly (last week)",
  "哈希链在第 {0}{1}条记录处断开：该记录或其后的记录被改动或删除，请立即上报": "Hash chain broken at record {0}{1}: that record or a later one was changed or deleted; report this immediately",
  "四、测试报文明细": "4. Test messages",
  "回复失败": "Reply failed",
  "回复时限（小时）": "Response time limit (hours)",
  "回执": "Acknowledgements",
  "回执已按真实伙伴回执处理，": "The acknowledgement was processed like a real partner acknowledgement.",
  "回执未通过": "Acknowledgement not passed",
  "回执（MDN）": "Receipt (MDN)",
  "团队处理异常后沉淀下来的方法。标注适用的预警类型后，同类预警的工单会自动推荐；工单关闭时也可以一键沉淀。": "How the team solved problems. Tag the alert types it applies to and work orders from those alerts recommend it; closing a work order can turn it into an article in one click.",
  "国家代码 (Country)": "Country code (C)",
  "国标平台文件": "National standard platform file",
  "国标平台文件不支持限定符": "National standard platform files do not support qualifiers",
  "国标平台文件没有交换控制号，按内容摘要去重": "National standard platform files have no control reference; duplicates are detected by content digest",
  "图片生成": "Image generation",
  "在{0}": "In {0}",
  "在上方搜索框输入订舱号、提单号等业务单号，系统将按时间正序回溯其全生命周期报文交互链条。": "Enter a booking number, B/L number or other reference above to trace its messages in time order.",
  "在下方“表达式”中编写。": "Write it in \"Expression\" below.",
  "在中间选择一个目标字段": "Select a target field in the middle",
  "在交换记录确认我方交换已发出、传输回执正常。": "Check in Interchanges that our interchange went out and the transport acknowledgement is normal.",
  "在报文中心查看全部": "View all in the message center",
  "在报文结构与内部业务模型之间按映射规则转换": "Convert between message structure and internal business model by mapping rules",
  "在报文诊断中打开该报文原文，看出错的段与位置。": "Open the original in message diagnosis to see the failing segment and position.",
  "在报文详情查看伙伴 CONTRL / APERAK 给出的错误代码（如 0085 语法错误代码 12 数据元值无效、13 缺少必需项）。": "See the error codes in the partner's CONTRL / APERAK in the message details (e.g. 0085 syntax error 12 invalid value, 13 missing).",
  "在报文详情查看各处理步骤耗时，常见为推送业务系统或外部连接响应慢。": "See the time of each processing step in the message details; usually pushing to the business system or an external connection is slow.",
  "在报文详情查看校验问题清单：缺少必填元素、代码不在实施指南（MIG）代码表、长度或格式不符。": "See the validation issues in the message details: missing mandatory elements, codes not in the MIG code list, wrong length or format.",
  "在接入管理测试该端口，看是网络、握手、认证还是证书问题。": "Test the port under Access management to see whether it is a network, handshake, authentication or certificate problem.",
  "在映射设计器中用该报文试跑，定位出错的规则与字段。": "Run the message in the mapping designer to find the failing rule and field.",
  "在途影响": "In-flight impact",
  "地址": "Address",
  "地址已改需重输": "Address changed, re-entry required",
  "地点": "Location",
  "场景": "Scenario",
  "基于 SSH 的安全文件传输": "Secure file transfer over SSH",
  "基本信息": "Basic info",
  "基础地址": "Base URL",
  "基础地址必须以 http:// 或 https:// 开头": "Base URL must start with http:// or https://",
  "填写 UN/EDIFACT 报文代码，例如 CODECO、IFTMIN、BAPLIE。系统将只解析该报文及其关联的目录定义。": "Enter the UN/EDIFACT message code, e.g. CODECO, IFTMIN, BAPLIE. Only that message and its directory definitions are parsed.",
  "填写外部码值": "Enter external code",
  "处理": "Processing",
  "处理失败": "Processing failed",
  "处理尝试时间线": "Processing attempts",
  "处理指引 · {0}": "Handling guide · {0}",
  "处理方向": "Direction",
  "处理时间": "Processed at",
  "处理时间范围": "Processing time",
  "处理未到映射步骤，没有业务数据": "Processing did not reach mapping; no business data",
  "处理步骤": "Steps",
  "处理知识库": "Knowledge base",
  "处理耗时上限": "Processing time limit",
  "备注": "Note",
  "复制": "Copy",
  "复制为我的映射": "Copy to my mappings",
  "复制公钥": "Copy public key",
  "复制对接信息": "Copy connection details",
  "复制已有映射": "Copy existing mapping",
  "复制自": "Copy from",
  "复制证书申请": "Copy certificate request",
  "复合元素": "Composites",
  "复合数据元": "Composite",
  "外部码值": "External code",
  "多个字段": "Several fields",
  "多个字段的值是列表，请先添加一个列表函数（合并、取首个非空、求和等）变成单值。": "Several fields give a list; add a list function first (join, first non-empty, sum…) to make one value.",
  "多个网段用逗号分隔。": "Separate ranges with commas.",
  "多报文交换": "Multi-message interchanges",
  "失败": "Failed",
  "失败原因": "Failure reasons",
  "失败原因: {0}": "Failure reason: {0}",
  "失败重试次数": "Retries on failure",
  "如 /edi/bookings，留空表示直接请求连接的基础地址": "E.g. /edi/bookings; leave empty to request the base URL directly",
  "如 IFTMBF, IFTMIN": "e.g. IFTMBF, IFTMIN",
  "如 ZZ / 01": "e.g. ZZ / 01",
  "如：AS2 证书轮换后伙伴验签失败": "e.g. Partner signature check fails after AS2 certificate rotation",
  "如：伙伴反映联系人电话有误，核对原文": "e.g. partner reports a wrong contact phone; checking the original",
  "字典导出失败": "Dictionary export failed",
  "字段": "Field",
  "字段名与来源节点完全一致": "Field name exactly matches the source node",
  "字段名包含于来源路径": "Field name is contained in the source path",
  "字段映射": "Field mapping",
  "字段格式不符": "Field format mismatch",
  "字母、数字或下划线，最长 35 位": "Letters, digits or underscores, up to 35",
  "字符编码": "Character encoding",
  "字符集（语法级别）": "Character set (syntax level)",
  "存储剩余下限": "Minimum free storage",
  "存储：执行归档（报文中心 → 归档与存储），清理已处理的发件目录，或扩容存储卷。": "Storage: run archiving (Message center → Archive and storage), clean up processed outbox files, or enlarge the volume.",
  "存在 {0} 个问题：": "{0} problems:",
  "存在未解决失败": "Unresolved failures",
  "存在重复的体系「{0}」": "Scheme \"{0}\" is duplicated",
  "存档目录剩余空间低于即告警": "Alert when free space in the archive folder drops below this",
  "季报（上季度）": "Quarterly (last quarter)",
  "宁波港": "Ningbo port",
  "安全要求": "Security",
  "完成": "Done",
  "完成时间": "Completed",
  "官": "Official",
  "官方": "Official",
  "官方 UN/EDIFACT 目录 ZIP（推荐）": "Official UN/EDIFACT directory ZIP (recommended)",
  "官方包解析成功：{0}，{1} 个结构节点": "Official package parsed: {0}, {1} structure nodes",
  "官方来源": "Official source",
  "官方标准包预检失败": "Official standard package pre-check failed",
  "官方节点定义加载失败": "Failed to load official node definition",
  "定义 / 映射": "Definition / mapping",
  "定义状态": "Definition status",
  "定时": "Schedule",
  "定时归档": "Scheduled archiving",
  "定时生成": "Scheduled generation",
  "审核中：{0} 提交于 {1}，结构已冻结": "In review: submitted by {0} at {1}; structure frozen",
  "审核已退回草稿": "Review returned to draft",
  "审核已通过，可发布": "Approved; ready to publish",
  "审核已通过，可继续启用配置": "Approved; you can enable the configuration",
  "审核通过": "Approve",
  "审核通过并发布": "Approve and publish",
  "审核通过并发布 {0}？": "Approve and publish {0}?",
  "审计报表": "Audit reports",
  "审计记录只增不改：数据库触发器拒绝修改与删除，每条记录的哈希包含上一条的哈希；本页不提供任何删除或编辑入口。": "Audit records are append-only: database triggers reject updates and deletes, and each record's hash includes the previous one's; this page has no delete or edit function.",
  "审计链在第 {0} 条断开": "Audit chain broken at record {0}",
  "审计链完整": "Audit chain intact",
  "客户端 ID (Client ID)": "Client ID",
  "客户端主动连接服务器数据端口，通常防火墙更友好": "Client initiates connection to server data port; typically firewall-friendly",
  "客户端密钥 (Client Secret)": "Client secret",
  "客户端认证方式": "Client authentication method",
  "客户端证书 (mTLS / 双向 TLS)": "Client certificate (mTLS / mutual TLS)",
  "客户端证书口令": "Client certificate password",
  "客户端证书引用": "Client certificate reference",
  "密码": "Password",
  "密码认证": "Password authentication",
  "密钥": "Key",
  "密钥引用": "Key reference",
  "密钥服务": "Key service",
  "密钥算法": "Key algorithm",
  "密钥长度": "Key length",
  "对应工作流": "Workflow",
  "对接信息已复制，可直接发给伙伴": "Connection details copied; send them to the partner",
  "对方加密": "Partner encryption",
  "对方若已收到将产生重复文件，请先确认对方未收到后再进行补发操作！": "If the partner already received it, they will get a duplicate file. Confirm they did not receive it before resending!",
  "对方验签": "Partner signature verification",
  "对每一条源记录生成一个列表元素": "One list element per source record",
  "对比版本：": "Compare with:",
  "对话": "Chat",
  "对话 LLM": "Chat LLM",
  "对象": "Object",
  "对象类型": "Object type",
  "导入已签发证书": "Import issued certificate",
  "导入新证书后会创建新版本，并使当前配置的连通性测试失效；重新测试通过后才能启用。私钥不会直接显示，仅可导出为受密码保护的PFX。": "Importing a new certificate creates a new version and invalidates the current connectivity test; it can be enabled only after a new test passes. The private key is never shown and can only be exported as a password-protected PFX.",
  "导出": "Export",
  "导出 Excel": "Export Excel",
  "将保存选中的 {0} 个节点及其内部连线为模板": "Will save {0} selected nodes and their internal connections as a template",
  "将同时删除其下 {0} 个节点。只影响当前草稿版本。": "Its {0} child nodes are deleted too. Only the current draft version is affected.",
  "将影响 {0} 个主体协议端口：{1}": "Affects {0} protocol ports: {1}",
  "将按工作流当前配置重新处理，创建新的尝试 {0}。原记录与历史结果均保持不变。": "Reprocessed with the workflow's current configuration as new attempt {0}. The original record and past results stay unchanged.",
  "将按工作流当前配置重新处理，创建新的尝试 {0}。只重跑失败的分支，上次已成功的分支不会再次投递；原记录与历史结果均保持不变。": "Reprocessed with the workflow's current configuration as new attempt {0}. Only failed branches run again; branches that succeeded last time are not delivered again. The original record and past results stay unchanged.",
  "尚未建立交换约定": "No exchange agreements yet",
  "尚未建立交换约定。": "No exchange agreements yet.",
  "尚未生成": "Not generated yet",
  "尚未进入生产": "Not in production yet",
  "尝试 {0}": "Attempt {0}",
  "尝试 {0}{1}": "Attempt {0}{1}",
  "尾记录位置不对": "Trailer record in wrong position",
  "展开查看全部 {0}{1}次处理尝试明细": "Show all {0}{1} processing attempts",
  "展开至半屏": "Expand to half screen",
  "属于": "in",
  "属伙伴问题时请伙伴修正后用新的交换控制号重发（同一控制号会被判为重复）。": "If the partner is at fault, ask them to fix it and resend with a new interchange control reference (the same reference counts as a duplicate).",
  "州/省 (ST)": "State / province (ST)",
  "工作流": "Workflow",
  "工作流不存在或加载失败": "Workflow not found or failed to load",
  "工作流中的本方发送方或接收方代码从此处获取，请添加本方报文标识": "Workflows take our sender or receiver code from here; add our message IDs",
  "工作流列表加载失败": "Failed to load workflows",
  "工作流加载失败": "Failed to load workflow",
  "工作流只保存主体和协议端口引用，不重复保存地址、账号或证书。": "The workflow stores only party and protocol port references, not addresses, accounts or certificates.",
  "工作流名称": "Workflow name",
  "工作流在保存时根据报文定义体系自动推导收发方代码；本方约定代码未设置时默认使用本方全局默认标识。": "Workflows derive the sender and receiver codes from the message definition's scheme on save; without our agreed code, our global default ID is used.",
  "工作流已保存": "Workflow saved",
  "工作流已停用": "Workflow disabled",
  "工作流已删除": "Workflow deleted",
  "工作流已发布到交换引擎（v{0}）": "Workflow published to the exchange engine (v{0})",
  "工作流已启用": "Workflow enabled",
  "工作流管理": "Workflows",
  "工作流草稿已创建": "Workflow draft created",
  "工单创建成功": "Work order created",
  "工单已核准闭环归档。关闭依据：{0}": "Work order approved and closed. Reason: {0}",
  "工单建立：{0}": "Work order opened: {0}",
  "工单来自这些预警时会自动推荐本条": "Recommended automatically for work orders from these alerts",
  "已上线，但近 24 小时没有收发报文": "Live, but no messages in the last 24 h",
  "已下发": "Pushed",
  "已保存": "Saved",
  "已保存 {0}": "Saved {0}",
  "已保存为草稿，但未能启用：{0}": "Saved as draft but could not be enabled: {0}",
  "已保存密码": "Password saved",
  "已保存证书主题：": "Saved certificate subject: ",
  "已停止": "Stopped",
  "已停用": "Disabled",
  "已关联它的工单会失去这条参考。": "Work orders linked to it lose this reference.",
  "已关闭": "Off",
  "已切换默认版本": "Default version switched",
  "已删除": "Deleted",
  "已发布 v{0}": "Published v{0}",
  "已发布到交换引擎": "Published to the exchange engine",
  "已发布或审核中的版本只读；派生一个草稿版本后在线调整结构": "Published or in-review versions are read-only; derive a draft version to edit the structure online",
  "已发送": "Sent",
  "已发送次数": "Times sent",
  "已取消": "Cancelled",
  "已取消关联": "Unlinked",
  "已另存为工作流模板": "Saved as workflow template",
  "已合并为交换": "Combined into interchange",
  "已吊销": "Revoked",
  "已启用": "Enabled",
  "已启用约定": "Enabled agreements",
  "已填入主机密钥指纹": "Host key fingerprint filled",
  "已处理": "Processed",
  "已处理（未投递）": "Processed (not delivered)",
  "已复制": "Copied",
  "已复制为我的映射": "Copied to my mappings",
  "已复制公钥到剪贴板": "Public key copied to clipboard",
  "已完成": "Done",
  "已完成预检：{0} 条记录待导入": "Pre-check done: {0} records to import",
  "已审核待发布": "Approved, not published",
  "已导入 {0} 条码值": "Imported {0} codes",
  "已导出 {0} 条": "Exported {0}",
  "已将所选节点保存为模板": "Selected nodes saved as template",
  "已废弃": "Deprecated",
  "已引用材料不能删除，请先解除引用": "Material in use cannot be deleted; remove the references first",
  "已恢复为最新版本": "Restored to the latest version",
  "已成功派生新版本": "New version derived",
  "已投递": "Delivered",
  "已拒绝": "Rejected",
  "已按最新表结构更新目标结构": "Target structure updated to the latest table structure",
  "已接受": "Accepted",
  "已接收": "Received",
  "已接通伙伴": "Connected partners",
  "已提": "Picked up",
  "已提交审核": "Submitted for review",
  "已插入「{0}」并重新连线": "Inserted \"{0}\" and reconnected",
  "已插入模板「{0}」": "Template \"{0}\" inserted",
  "已新建知识条目": "Knowledge article created",
  "已映射": "Mapped",
  "已更换密钥": "Key replaced",
  "已标记为不需要：{0}": "Marked as not needed: {0}",
  "已标记为本工单采用的方法": "Marked as the method used for this work order",
  "已沉淀到知识库并关联本工单": "Saved to the knowledge base and linked to this work order",
  "已派生草稿版本 {0}，可以编辑结构了": "Draft version {0} derived; you can edit the structure now",
  "已添加「{0}」并连线": "Added \"{0}\" and connected",
  "已添加「{0}」节点": "Node \"{0}\" added",
  "已生成报表": "Report generated",
  "已生成新处理尝试 {0}": "New processing attempt {0} created",
  "已生成的标准清单 JSON（兼容）": "Generated standard list JSON (compatibility)",
  "已生成至 {0}": "Generated up to {0}",
  "已生成补发记录 {0}": "Resend record {0} created",
  "已生效（网关 /edi/v1/as2 接收）": "Active (gateway /edi/v1/as2 receives)",
  "已生效（网关 /edi/v1/inbound 接收）": "Active (gateway /edi/v1/inbound receives)",
  "已生效（网关按端口到伙伴服务器取件）": "Active (gateway collects from the partner server per port)",
  "已登记的全部交易伙伴": "All registered trading partners",
  "已自动保存 {0}": "Auto-saved {0}",
  "已补发": "Resent",
  "已补发成功": "Resent successfully",
  "已被替换": "Superseded",
  "已解析 {0} 条码值，确认后将写入字典台账": "Parsed {0} codes; they are written to the dictionary after you confirm",
  "已解除该证书与伙伴的关联": "Certificate unlinked from the partner",
  "已设为基准": "Set as baseline",
  "已设置": "Configured",
  "已读取证书文件：{0}": "Certificate file read: {0}",
  "已超时": "Timed out",
  "已跳过": "Skipped",
  "已过截单时间的，与船司协商补料（late SI）安排。": "If the cut-off has passed, arrange a late SI with the carrier.",
  "已过期": "Expired",
  "已过期 {0} 天": "Expired {0} days ago",
  "已退回草稿": "Returned to draft",
  "已选择 {0}": "Selected {0}",
  "已选证书：{0}（点击替换）": "Selected certificate: {0} (click to replace)",
  "已配置自动切换的通道会切到备用通道；通道恢复后预警自动关闭，期间未发出的报文请「补发」。": "Channels with automatic failover switch to the backup; the alert closes when the channel recovers; \"Resend\" messages not sent meanwhile.",
  "已采用": "Used",
  "已重处理": "Reprocessed",
  "已重处理成功": "Reprocessed successfully",
  "已重置接入密钥，旧密钥立即失效": "Access key reset; the old key stops working immediately",
  "已隐藏联系人姓名、电话与邮箱": "Contact names, phone numbers and e-mail addresses are hidden",
  "帮助与说明": "Help",
  "常量": "Constant",
  "平台": "Platform",
  "平台公钥": "Platform public key",
  "平台内置 · 只读": "Built in · read-only",
  "平台内置定义只读，可直接在交换约定中选用": "Built-in definitions are read-only and can be selected directly in exchange agreements",
  "平台内置定义由交换引擎按实施指南（MIG）校验：信封与计数、段顺序与出现次数、必备段与数据元、数据元表示法（a/an/n与长度）、限定代码。校验结果在报文中心逐项给出位置。": "Built-in definitions are validated by the engine per the MIG: envelope and counts, segment order and occurrences, mandatory segments and elements, data element representation (a/an/n and length), qualifier codes. Results are listed by position in the message center.",
  "平台内置定义由交换引擎直接执行，不在标准库里保存结构版本，无法做结构对比。可以派生一个库版本后比较。": "Built-in definitions are executed directly by the exchange engine and have no structure versions in the library, so they cannot be compared. Derive a library version to compare.",
  "平台发件目录（按接收方分目录）": "Platform outbox (one folder per receiver)",
  "平台固定执行：接收即存档 → 识别伙伴 → 去重 → 合规校验 → 映射为标准业务数据；约定只决定用哪个报文定义、哪版映射、走哪个端口、回执怎么要求。内部系统怎么接收由共享的业务流程决定，新增伙伴不用再画流程。": "The platform always runs: archive on receipt → identify partner → de-duplicate → validate → map to canonical business data. The agreement only decides which message definition, mapping version, port and acknowledgements to use. How internal systems receive the data is decided by the shared business flow, so adding a partner needs no new flow.",
  "平台按信封识别伙伴与约定，同一控制号 30天内重复投递会被判为重复；约定要求时自动回复 CONTRL。": "The platform identifies partner and agreement from the envelope; the same control reference delivered again within 30 days is a duplicate; CONTRL is replied automatically when the agreement asks for it.",
  "平台收件目录": "Platform inbox",
  "平台收发目录（不经网关）": "Platform exchange folders (no gateway)",
  "平台文件": "Platform file",
  "平台用密钥对登录，不保存伙伴密码。请伙伴把下面的公钥加入该账号的authorized_keys": "The platform logs in with a key pair and stores no partner password. Ask the partner to add this public key to the account's authorized_keys",
  "平台登录公钥": "Platform login public key",
  "并配置协议端口": "and configure protocol ports",
  "应用回复": "Application reply",
  "应用回执": "Application acknowledgement",
  "应用失败": "Apply failed",
  "应用确认": "Application acknowledgement",
  "建议关注失败记录": "Check the failure records",
  "开启后，每个周期结束后一小时内自动生成（按北京时间）。": "When on, a report is generated within an hour after each period ends (Beijing time).",
  "开始 / 结束": "Start / end",
  "开始归档": "Start archiving",
  "开始搭建工作流": "Start building workflow",
  "开始时间": "Started",
  "开放平台 Token 获取失败": "Failed to get open platform token",
  "异常": "Exception",
  "异常类型构成": "By type",
  "异步": "Asynchronous",
  "异步 MDN URL": "Async MDN URL",
  "异步 MDN 地址": "Async MDN URL",
  "引擎未设置 EDI_ENGINE_ARCHIVE_KEY（32 字节 base64），不会进行归档，所有内容保留在数据库中。请由运维配置后重启引擎。": "The engine has no EDI_ENGINE_ARCHIVE_KEY (32-byte base64), so nothing is archived and everything stays in the database. Ask operations to configure it and restart the engine.",
  "引用": "References",
  "引用 SSH 主机密钥材料；此处不接受 X.509 证书。": "References SSH host key material; X.509 certificates are not accepted here.",
  "引用它的工作流将失去这个连接。": "Workflows that use it will lose this connection.",
  "引用该映射的工作流": "Workflows using this mapping",
  "引用该连接的工作流": "Workflows referencing this connection",
  "归档": "Archive",
  "归档与存储": "Archive and storage",
  "归档任务": "Archive jobs",
  "归档位置": "Archive location",
  "归档存储": "Archive storage",
  "归档完成：报文 {0}、交换 {1}{2}": "Archiving done: messages {0}, interchanges {1}{2}",
  "归档密钥未配置": "Archive key not configured",
  "归档截止": "Archive before",
  "当前业务单号": "Business reference",
  "当前业务状态": "Current status",
  "当前仅支持 UTF-8 编码的 CSV 文件": "Only UTF-8 CSV files are supported",
  "当前企业无权访问此应用": "The current organization cannot access this app",
  "当前会话缺少 memberUuid，请先完成登录并刷新当前用户信息": "The session has no memberUuid; sign in and refresh the current user first",
  "当前时段暂无预警触发": "No alerts in this period",
  "当前查看": "Viewing",
  "当前查看: 尝试 {0} / 共 {1} 次尝试": "Viewing: attempt {0} of {1}",
  "当前样例：": "Current sample:",
  "当前模型": "Current model",
  "当前模型已更新": "Model updated",
  "当前登录凭证不可用，请返回工作台重新进入应用。": "Your login credentials are no longer valid; return to the workbench and open the app again.",
  "当前空间内的流程总数": "Flows in this space",
  "当前绑定该版本的伙伴：{0}{1}家。": "Partners currently on this version: {0}{1}.",
  "当前节点使用旧版直接推送地址。推荐改用业务系统连接统一管理地址与认证凭据，多个流程可复用。": "This node uses a legacy direct delivery URL. We recommend switching to a system connection to centrally manage addresses and credentials for reuse across workflows.",
  "当前视图下没有伙伴": "No partners in this view",
  "当前选择包含 {0}，{1}": "The selection contains {0}, {1}",
  "影响预览": "Impact preview",
  "影响预览失败": "Impact preview failed",
  "待审核": "Pending review",
  "循环": "Loop",
  "循环 ← {0} ({1})": "Loop ← {0} ({1})",
  "循环不存在": "Loop does not exist",
  "循环内的字段从左侧同一记录中拖入；读取循环外的字段会以 $. 开头。": "Fields inside the loop are dragged from the same record on the left; fields outside the loop start with $.",
  "循环设置": "Loop settings",
  "德国 / 汉堡（CET）": "Germany / Hamburg (CET)",
  "必填": "Required",
  "必填、格式（日期、数值等）、长度（按 GBK 字节）、代码值": "Required, format (date, number…), length (GBK bytes), codes",
  "必填变化": "Required changed",
  "必填字段为空": "Required field empty",
  "必填未映射": "Required, unmapped",
  "必填项为空": "Required value empty",
  "必须": "Required",
  "总数": "Total",
  "总耗时": "Total duration",
  "恢复条件": "Recovery condition",
  "恢复默认宽度": "Restore default width",
  "成功": "Succeeded",
  "成功判定": "Success",
  "成功率": "Success rate",
  "我方 MIG 过严：在报文标准库派生企业版本放宽后，在交换约定中切换版本，再对该报文「重处理」。": "Our MIG is too strict: derive and relax an organization version in the standards library, switch the agreement to it, then reprocess the message.",
  "我方发往目录": "Our outbound folder",
  "我方发给伙伴的文件写入伙伴服务器的该目录": "Files we send are written to this folder on the partner's server",
  "我方发送时的认证": "Authentication when we send",
  "我的工作流{0}": "My workflows{0}",
  "我的模板": "My templates",
  "截单前未发送 SI / VGM": "SI / VGM not sent before cut-off",
  "截单前预警提前量": "Warn before cut-off",
  "截单时间所在时区": "Time zone of cut-off times",
  "截单时间的时区、节假日与 SI/VGM开航前小时数按伙伴设置：交易伙伴 → 交换约定 → 截单规则。": "Cut-off time zone, holidays and SI/VGM hours before departure are set per partner: Trading partners → Exchange agreements → Cut-off rule.",
  "截单规则已保存，之后收到或发出的订舱确认按此计算截单时间": "Cut-off rule saved; booking confirmations received or sent from now on use it",
  "截单规则（SI / VGM 时效）": "Cut-off rule (SI / VGM deadlines)",
  "截止": "Due",
  "所含报文（{0}）": "Messages ({0})",
  "所在地 (L)": "Locality (L)",
  "所有伙伴按交换约定转换好的标准业务数据从这里进入；平台已完成接收、识别、去重、校验与映射": "Canonical business data from all partners, already converted under their agreements, enters here; the platform has already received, identified, de-duplicated, validated and mapped it",
  "所有在用交换约定均已有通过的测试报文。": "Every agreement in use has a passed test message.",
  "所有工作流合计": "All workflows combined",
  "所有配置变更与报文操作的留痕：操作人、时间、终端 IP、操作前后数据": "Trail of every configuration change and message operation: operator, time, client IP, data before and after",
  "手动": "Manual",
  "打印 / PDF": "Print / PDF",
  "打印 / 另存为 PDF": "Print / save as PDF",
  "托运指示(SI)": "Shipping instruction (SI)",
  "托运指示（SI）": "Shipping instruction (SI)",
  "执行器未接入": "Executor not connected",
  "扮演伙伴或业务系统，把收发主线在真实约定上跑一遍；结果进入报文中心，与生产数据一样可追溯": "Act as a partner or business system and run the exchange end to end on real agreements; results land in the message center and are traceable like production data",
  "批量切换版本（{0} 条约定）": "Switch version for {0} agreements",
  "批量切换版本（{0}）": "Switch version ({0})",
  "批量发送": "Batch send",
  "批量发送失败": "Batch send failed",
  "批量导入码值字典（CSV）": "Import code dictionary (CSV)",
  "批量报文处理": "Batch message processing",
  "找不到报文 {0}，或它不属于当前企业": "Message {0} not found, or it does not belong to the current organization",
  "把 {0} 天前完成的报文与交换文件加密转入归档存储。归档后仍可在报文中心查看，平台不会删除任何内容。": "Encrypt and move messages and interchange files completed more than {0} days ago into archive storage. They stay viewable in the message center; the platform never deletes anything.",
  "把一个可重复记录从左侧拖到这里建立循环": "Drag a repeating record from the left here to create a loop",
  "把一份输入复制到所有下游分支，各分支独立映射与投递，失败只重跑该分支": "Copy one input to all downstream branches; each branch maps and delivers independently and only a failed branch is rerun",
  "把业务数据以 JSON 推送给业务系统，失败按配置重试": "Push business data as JSON to the business system, retrying as configured on failure",
  "审核通过时已自动发布；引擎当时不可用或需要重新同步时，可在此重新发布": "Approval already published it; republish here if the engine was unavailable then or needs resyncing",
  "只有审核通过的版本才能发布到交换引擎：草稿还会修改，提前发布会让后续修改直接影响正在运行的约定": "Only approved versions can be published to the engine: a draft can still change, and publishing it early would let later edits affect live agreements",
  "通过后自动发布到交换引擎，即可在交换约定中选用；已上线的约定仍使用原来的报文定义版本，确认后在约定里切换。": "Approval publishes it to the exchange engine so agreements can select it; live agreements keep their current definition version until you switch them.",
  "审核已通过，但发布到交换引擎失败": "Approved, but publishing to the exchange engine failed",
  "（该方向暂无映射）": " (no mapping in this direction yet)",
  "启用前请选择映射；可先保存草稿，建好映射后再启用": "Select a mapping before enabling; save a draft now and enable it once the mapping exists",
  "只列出交换引擎可执行的报文定义；标准库里的报文审核通过后会自动发布到引擎，之后出现在这里。": "Only definitions the exchange engine can run are listed; library messages are published to the engine on approval and appear here afterwards.",
  "去报文标准库": "Open the message library",
  "该方向暂无映射，可先保存草稿": "No mapping in this direction yet; you can save a draft",
  "未选择映射，暂不能启用": "No mapping selected; cannot be enabled yet",
  "未选择映射": "No mapping selected",
  "语义标签": "Semantic role",
  "回复配对与去重按它识别同一张单": "Replies and duplicates are matched to the same document by it",
  "平台用于：{0}": "Used by the platform for: {0}",
  "平台功能": "platform features",
  "订单号": "Order no.",
  "SI 编号": "SI no.",
  "SI 截止": "SI cut-off",
  "VGM 截止": "VGM cut-off",
  "预计离港": "Estimated departure",
  "单号检索、回复配对": "reference search, reply matching",
  "单号检索": "reference search",
  "箱号检索": "container search",
  "截单预警": "cut-off warnings",
  "截单时间推算": "cut-off derivation",
  "业务单据数组，每个元素是一票": "Array of business documents, one per element",
  "{0}转换出的业务单据，即业务流程将收到的内容": "Business document produced by {0}, i.e. what the business flow will receive",
  "业务单据": "Business document",
  "业务单据数据（JSON）": "Business document (JSON)",
  "所有伙伴按交换约定转换好的业务单据从这里进入；平台已完成接收、识别、去重、校验与映射": "Business document from all partners, already converted under their agreements, enters here; the platform has already received, identified, de-duplicated, validated and mapped it",
  "（process、partner 与 items：每项一个 eventId和一票业务单据）。这里用同一接口手工演练： EDIFACT约定下所有票合并成一个交换（一个 UNB、每票一对UNH…UNT、一个交换控制号）；有问题的票单独记录为未发送，不影响其他票；重复的 eventId返回原记录，不会重复发送。": " (process, partner and items: one eventId and one business document per item). Try the same endpoint by hand here: under an EDIFACT agreement all documents go into one interchange (one UNB, one UNH…UNT pair per document, one control reference); a problem document is recorded as not sent without affecting the others; a repeated eventId returns the original record and is not sent again.",
  "查看单据结构": "View document structure",
  "平台固定执行：接收即存档 → 识别伙伴 → 去重 → 合规校验 → 映射为业务单据；约定只决定用哪个报文定义、哪版映射、走哪个端口、回执怎么要求。内部系统怎么接收由共享的业务流程决定，新增伙伴不用再画流程。": "The platform always archives on receipt, identifies the partner, removes duplicates, validates and maps to a business document; the agreement only decides the message definition, mapping version, connector and acknowledgement rules. How internal systems receive the data is decided by the shared business flow, so new partners need no new flow.",
  "映射：报文 → 业务单据": "Mapping: message → business document",
  "映射：业务单据 → 报文": "Mapping: business document → message",
  "对应单据：{0}": "Document: {0}",
  "转换好的业务单据交给哪个业务流程投递到内部系统；同一种单据的所有伙伴共用一个流程": "The business flow that delivers the converted document to internal systems; all partners of the same document share one flow",
  "业务单据不存在或交换引擎暂时无法访问": "The business document does not exist or the exchange engine is unreachable",
  "返回业务单据": "Back to business documents",
  "平台单据 · 只读": "Platform document · read-only",
  "字段数": "Fields",
  "业务单号字段": "Business key field",
  "导出接口说明": "Export interface description",
  "字段结构": "Fields",
  "可重复": "Repeatable",
  "码值": "Codes",
  "样例": "Sample",
  "每个字段填一个示例值，可重复的部分给一条。入站时内部系统收到的、出站时内部系统发送的，都是这个结构。": "Every field filled with an example value, repeated parts with one entry. Internal systems receive this structure inbound and send it outbound.",
  "被引用（{0}）": "Used by ({0})",
  "单据 → {0}": "Document → {0}",
  "{0} → 单据": "{0} → document",
  "业务单据是内部系统与平台之间的数据格式：所有伙伴的报文都转换成同一张单据交给内部系统，内部系统也按它把业务数据交给平台发给伙伴。": "A business document is the data format between internal systems and the platform: every partner's messages become the same document for internal systems, and internal systems hand data to the platform in it for partners.",
  "平台单据参考 DCSA 预置，目前只读；企业派生扩展与自建单据在后续版本提供。": "Platform documents are preset after DCSA and read-only for now; extending and creating your own documents comes in a later release.",
  "单据名称": "Document",
  "单据编码": "Document code",
  "被引用": "Used by",
  "映射 {0}": "Mappings {0}",
  "约定 {0}": "Agreements {0}",
  "业务流程 {0}": "Business flows {0}",
  "查看结构": "View structure",
  "字段表、样例与发送方式，可直接发给内部系统开发": "Field table, sample and how to send; ready for internal system developers",
  "接口说明": "Interface description",
  "数字": "Number",
  "是/否": "Yes/No",
  "装卸船指令（箱清单）": "Container handling order",
  "托运指示（SI 补料）": "Shipping instruction",
  "提单（草稿确认与签发）": "Transport document",
  "核实总重（VGM）": "Verified gross mass (VGM)",
  "引擎可用（平台内置）": "In engine (built-in)",
  "交换引擎内置的定义，可直接在交换约定中选用": "Built into the exchange engine; select it directly in exchange agreements",
  "引擎可用": "In engine",
  "已发布到交换引擎，可在交换约定中选用": "Published to the exchange engine; selectable in exchange agreements",
  "已审核，未进引擎": "Approved, not in engine",
  "审核已通过但交换引擎里没有，到详情页点「发布到交换引擎」": "Approved but missing from the exchange engine; open the details and click \"Publish to exchange engine\"",
  "已审核": "Approved",
  "交换引擎暂时无法访问，无法确认是否可在约定中选用": "The exchange engine is unreachable, so availability in agreements cannot be confirmed",
  "审核中": "In review",
  "审核通过后自动发布到交换引擎": "Published to the exchange engine automatically once approved",
  "提交审核并通过后才会发布到交换引擎": "Published to the exchange engine only after it is submitted and approved",
  "目录待导入": "Catalog pending import",
  "只有目录，尚无报文结构": "Catalog entry only; no message structure yet",
  "发布状态": "Publish status",
  "交换约定可选用的版本：{0}": "Versions selectable in exchange agreements: {0}",
  "{0}。请稍后点击「发布到交换引擎」重试。": "{0}. Click \"Publish to exchange engine\" later to retry.",
  "把报文结构与业务模型的字段对应起来。映射按版本发布，工作流引用固定版本。": "Map message structure fields to business model fields. Mappings are published in versions and workflows use a fixed version.",
  "把映射后的业务数据写入数据库表，按键列判断新增或更新，一份报文的所有行在一个事务里提交": "Write mapped business data to database tables, inserting or updating by key columns; all rows of one message commit in one transaction",
  "把生成的报文写入平台发件目录，或用平台密钥推送到伙伴 SFTP 服务器": "Write the generated message to the platform outbox, or push it to the partner's SFTP server with the platform key",
  "投递业务系统": "Deliver to business system",
  "投递失败": "Delivery failed",
  "报文": "Message",
  "报文 {0}": "Message {0}",
  "报文 {0} · 交换 {1} ·{2}": "Messages {0} · interchanges {1} ·{2}",
  "报文下载开始": "Download started",
  "报文不存在": "Message not found",
  "报文与映射": "Message and mapping",
  "报文中的联系人姓名、电话与邮箱属于个人信息，默认隐藏。显示原文需填写原因，操作人、时间、终端与原因会记入操作审计；显示后下载的也是原文。": "Contact names, phone numbers and e-mail addresses in messages are personal data and hidden by default. Showing the original needs a reason; operator, time, client and reason are recorded in the operation audit. Downloads after showing are the original.",
  "报文交互时间线": "Message timeline",
  "报文信封中的收发方由交易伙伴的「报文标识」与本方 Profile 推导，不在这里填写。": "Sender and receiver in the envelope come from the partner's \"Message IDs\" and our profile; they are not entered here.",
  "报文内容": "Message content",
  "报文参考号": "Message reference",
  "报文发送": "Send message",
  "报文发送失败": "Message sending failed",
  "报文处理超时": "Message processing too slow",
  "报文头的类型与所选定义一致": "Message type in the header matches the selected definition",
  "报文定义": "Message definition",
  "报文定义 {0}（{1} · {2}）第 {3} 版已可执行：在映射设计器以它为源或目标建映射，再在交换约定中选择即可收发。": "Message definition {0} ({1} · {2}) version {3} is executable: build a mapping with it as source or target in the mapping designer, then select it in an exchange agreement.",
  "报文定义（MIG）": "Message definition (MIG)",
  "报文接收": "Receive message",
  "报文收发": "Message exchange",
  "报文收发、失败原因、合规校验、预警工单与操作审计的周期汇总，可导出 Excel 或打印为 PDF": "Periodic summary of message exchange, failure reasons, validation, alerts and work orders, and operation audit; export to Excel or print to PDF",
  "报文数": "Messages",
  "报文文件": "Message file",
  "报文文件名": "File name",
  "报文无法解析": "Message cannot be parsed",
  "报文未通过合规校验": "Message failed validation",
  "报文标准": "Message standards",
  "报文标准创建成功": "Message standard created",
  "报文标识": "message IDs",
  "报文标识已保存": "Message IDs saved",
  "报文段": "Segment",
  "报文生成": "Generate message",
  "报文类型": "Message type",
  "报文类型与功能": "Message type and function",
  "报文类型与定义不符": "Message type does not match the definition",
  "报文结构": "Message structure",
  "报文编号": "Message ID",
  "报文解析": "Parse message",
  "报文记录": "Message record",
  "报文诊断": "Message diagnosis",
  "报文转换失败": "Message mapping failed",
  "报文顶层": "top level",
  "报表": "Report",
  "报错": "Fail",
  "报错信息、影响范围、如何发现": "Error messages, impact, how it was noticed",
  "拒绝": "Reject",
  "拓扑": "Topology",
  "拖到中间的目标字段": "Drag onto a target field in the middle",
  "拦截并告警（推荐）": "Block and alert (recommended)",
  "拦截：报文处理失败，": "Block: message processing fails,",
  "持续失败请与伙伴确认端口配置是否变更。": "If it keeps failing, confirm with the partner whether the port configuration changed.",
  "指派处理人": "Assign to",
  "指纹": "Fingerprint",
  "指纹 (SHA-256)": "Fingerprint (SHA-256)",
  "按 GB/T 集装箱运输 EDI 报文定义生成平台文件": "Generate platform files per the GB/T container transport EDI message definitions",
  "按 GB/T 集装箱运输 EDI 报文定义解析平台文件": "Parse platform files per the GB/T container transport EDI message definitions",
  "按 GB/T 集装箱运输 EDI 报文定义解析或生成平台文件": "Parse or generate platform files per the GB/T container transport EDI message definitions",
  "按 {0} 编码读取": "Read as {0}",
  "按「报文发送失败」排查端口与网络。": "Troubleshoot the port and network as for \"Message sending failed\".",
  "按伙伴筛选": "Filter by partner",
  "按当前筛选条件导出全部结果（CSV，可直接用 Excel 打开；最多 {0} 条）": "Export all results for the current filters (CSV, opens in Excel; up to {0})",
  "按报文定义校验记录结构、必填、格式、长度与代码值": "Validate record structure, required fields, format, length and codes against the message definition",
  "按报文定义解析": "Parse by definition",
  "按报文编号或业务单号搜索；原文会复制到样例中，不依赖原记录": "Search by message ID or business reference; the original is copied into the sample and does not depend on the record",
  "按格式自动分到各渠道：HTTPS 地址走 Webhook（企业微信、钉钉、飞书群机器人自动按其格式发送，钉钉/飞书加签在地址后加 #secret=密钥）；邮箱走邮件；手机号走短信。邮件与短信需运维配置发送服务。": "Recipients are routed by format: HTTPS URLs go to webhook (WeCom, DingTalk and Feishu group bots get their own format; for DingTalk/Feishu signing add #secret=<key> after the URL); e-mail addresses go to email; mobile numbers go to SMS. Email and SMS need the sending services configured by operations.",
  "按此定义生成报文；报文头的类型、收发方与时间由引擎填写": "Messages are generated with this definition; type, sender, receiver and time in the header are filled in by the engine",
  "按此定义解析伙伴报文；报文类型参与匹配伙伴报文": "Partner messages are parsed with this definition; the message type is used to match partner messages",
  "按类型": "By type",
  "按约定生成样例": "Generate sample from agreement",
  "按约定的映射": "Mapping of the agreement",
  "按触发次数统计，点击图例或柱形筛选明细": "By trigger count; click the legend or a bar to filter details",
  "按钮插入新节点。": "button between nodes or at a branch end to insert a node.",
  "按键列存在就更新、不存在就插入；一份报文的所有行在一个事务里写入": "Rows are updated when the key exists and inserted otherwise; all rows of one message are written in one transaction",
  "按预警类型": "By alert type",
  "授权服务未完成登录，请重新登录。": "The authorization service did not complete sign-in; please sign in again.",
  "授权范围 (Scope)": "Scope",
  "接入伙伴": "Partner",
  "接入信息": "Access details",
  "接入外部系统所需的地址与凭据。密码只写不读，工作流通过这里的连接读表或写入目标。": "Addresses and credentials for external systems. Passwords are write-only; workflows read or write targets through these connections.",
  "接入密钥": "Access key",
  "接入管理": "Access management",
  "接入通道不可达": "Channel unreachable",
  "接受": "Accept",
  "接受为新基准": "Accept as new baseline",
  "接口": "Endpoint",
  "接收": "Receive",
  "接收 URL": "Receiving URL",
  "接收/创建时间": "Received / created at",
  "接收主体": "Receiving party",
  "接收地址": "Receiving URL",
  "接收方": "Receiver",
  "接收方主体": "Receiver",
  "接收时间": "Received at",
  "控制号": "Control reference",
  "控制端口": "Control port",
  "推送业务数据至 REST 接口": "Push business data to REST APIs",
  "推送令牌摘要": "Push token digest",
  "推送地址": "Push address",
  "描述该连接的用途及对应业务系统": "Describe the purpose of this connection and target business system",
  "描述（可选）": "Description (optional)",
  "提交 {0} 审核？": "Submit {0} for review?",
  "提交变更审核": "Submit changes for review",
  "提交后结构冻结，由另一位有发布权限的成员审核：通过即发布，退回会附原因并回到草稿。": "After submitting, the structure is frozen and reviewed by another member with publishing permission: approval publishes it, rejection returns it to draft with a reason.",
  "提交地址": "Submission URL",
  "提交审核": "Submit for review",
  "提交接口 · {0}": "Submission API · {0}",
  "提交的业务数据": "Submitted business data",
  "提交的数据": "Submitted data",
  "提交编号": "Submission ID",
  "提单": "Bill of lading",
  "提单号": "B/L no.",
  "提单确认": "B/L confirmation",
  "插入「{0}」": "Insert \"{0}\"",
  "搜索名称、主机或用户名": "Search name, host or user",
  "搜索名称或接入伙伴": "Search name or partner",
  "搜索名称或编号": "Search name or ID",
  "搜索字段": "Search fields",
  "搜索报文编号或业务单号": "Search message ID or reference",
  "搜索标题、现象、步骤、关键词": "Search title, symptom, steps, keywords",
  "搜索模板名称或描述...": "Search template name or description...",
  "搜索源字段": "Search source fields",
  "搜索节点类型或描述...": "Search node type or description...",
  "操作": "Actions",
  "操作、对象编号": "Operation, object ID",
  "操作人": "Operator",
  "操作人 ID": "Operator ID",
  "操作人: {0}": "Operator: {0}",
  "操作前": "Before",
  "操作后": "After",
  "操作失败": "Operation failed",
  "操作审计": "Operation audit",
  "操作审计：{0} 次操作，{1} 次失败": "Operation audit: {0} operations, {1} failed",
  "操作菜单": "Actions",
  "支持CER、CRT、DER、KEY、P12、P7B、PEM、PFX、PPK、PUB；每次仅导入一个文件。": "Supports CER, CRT, DER, KEY, P12, P7B, PEM, PFX, PPK, PUB; one file per import.",
  "支持上传 .p12 或 .pfx 格式证书文件": "Supports uploading .p12 or .pfx certificate files",
  "收": "In",
  "收件目录": "Inbox folder",
  "收到": "Received",
  "收到后回复 CONTRL": "Reply with CONTRL on receipt",
  "收到的": "Received",
  "收发方代码": "Sender / receiver codes",
  "收发方代码来自在发送节点选择的交易伙伴及本方报文标识，将在保存时自动更新。": "Sender and receiver codes come from the partner selected in the send node and our message IDs, and are updated on save.",
  "收发方代码来自在接收节点选择的交易伙伴及本方报文标识，将在保存时自动更新。": "Sender and receiver codes come from the partner selected in the receive node and our message IDs, and are updated on save.",
  "收发模拟": "Exchange simulator",
  "收发的每个文件：信封、控制号、所含报文与回执": "Every file exchanged: envelope, control reference, messages and acknowledgements",
  "收起高级筛选": "Hide advanced filters",
  "收：加密": "Receive: encrypted",
  "收：签名": "Receive: signed",
  "改用业务系统连接": "Switch to system connection",
  "放大画布": "Zoom in",
  "放弃修改": "Discard changes",
  "放弃草稿修改？": "Discard draft changes?",
  "放箱": "Released",
  "放箱指令": "Release order",
  "数值": "Number",
  "数据元": "Data element",
  "数据元过多": "Too many data elements",
  "数据库": "Database",
  "数据库写入": "Write to database",
  "数据库名": "Database name",
  "数据库类型": "Database type",
  "数据库表": "Database table",
  "数据库表已经变了，下面是草稿快照和表当前结构的差异": "The database table has changed; below are the differences between the draft snapshot and the current table",
  "数据库连接": "Database connection",
  "数据统计范围：最近 7 天": "Statistics: last 7 days",
  "数据表": "Table",
  "数量": "Count",
  "文件名": "File name",
  "文件服务器": "File servers",
  "文件过滤规则": "File filter",
  "文本": "Text",
  "文本转语音": "Text to speech",
  "新伙伴上线四步": "Four steps to onboard a partner",
  "新公钥证书材料 (.cer / .pem)": "New public certificate (.cer / .pem)",
  "新加坡（UTC+8）": "Singapore (UTC+8)",
  "新增": "Added",
  "新增 {0}": "Added {0}",
  "新增列": "Columns added",
  "新增列「{0}」（{1}）": "Column \"{0}\" added ({1})",
  "新建 HTTP 连接": "New HTTP connection",
  "新建交换约定": "New exchange agreement",
  "新建工作流": "New workflow",
  "新建工单": "Work orders opened",
  "新建映射": "New mapping",
  "新建条目": "New article",
  "新建知识条目": "New article",
  "新建连接": "New connection",
  "新建连接 - {0}": "New connection - {0}",
  "新版本名称，如 D.99B-COSCO-2": "New version name, e.g. D.99B-COSCO-2",
  "新的报文定义（目录版本 / MIG）": "New message definition (directory version / MIG)",
  "新证书名称": "New certificate name",
  "方向": "Direction",
  "方法": "Method",
  "无": "None",
  "无交换": "No exchanges",
  "无法解析": "Cannot parse",
  "无法解析官方 UN/EDIFACT ZIP 文件": "Cannot parse the official UN/EDIFACT ZIP file",
  "无法识别": "Not recognised",
  "无法读取标准包 JSON 文件": "Cannot read the standard package JSON file",
  "无类型兼容的后续节点": "No compatible next nodes",
  "无详细描述": "No description",
  "无需凭据": "No credentials needed",
  "日报（昨天）": "Daily (yesterday)",
  "日期": "Date",
  "日期时间": "Date and time",
  "日期：": "Date:",
  "日本語": "日本語",
  "日本（UTC+9）": "Japan (UTC+9)",
  "旧密钥立即失效，所有业务系统需要换成新密钥。": "The old key stops working immediately; every business system must switch to the new key.",
  "旧版直接推送地址": "Legacy direct delivery URL",
  "时效异常": "Deadline issue",
  "时间": "Time",
  "明文（PORT 21）": "Plain (PORT 21)",
  "映射": "Mapping",
  "映射从哪个结构读取数据": "The structure the mapping reads from",
  "映射加载失败": "Failed to load mapping",
  "映射后的业务数据以 JSON POST 到此地址，请求头 X-EDI-Message-Id 可用于去重": "Mapped business data is POSTed to this URL as JSON; the X-EDI-Message-Id header can be used for de-duplication",
  "映射已创建": "Mapping created",
  "映射已被其他人修改": "Mapping changed by someone else",
  "映射把数据写成哪个结构": "The structure the mapping writes",
  "映射把数据写成哪类结构": "The kind of structure the mapping writes",
  "映射版本": "Mapping version",
  "映射由交换引擎预置，在此只读查看；可视化编辑在后续计划中": "The mapping is preset by the exchange engine and shown read-only here; visual editing is planned",
  "映射目标会记住这张表当时的列结构，表结构变化后用设计器里的「刷新表结构」对比": "The target remembers the table's columns at this point; after the table changes, compare with \"Refresh table structure\" in the designer",
  "映射规则": "Mapping rules",
  "映射：报文 → 标准业务数据": "Mapping: message → canonical business data",
  "映射：标准业务数据 → 报文": "Mapping: canonical business data → message",
  "是否": "Yes / no",
  "是（CONTRL）": "Yes (CONTRL)",
  "显式 FTPS": "Explicit FTPS",
  "显式 TLS（AUTH TLS）": "Explicit TLS (AUTH TLS)",
  "显示": "Show",
  "显示个人信息": "Show personal data",
  "显示全部尝试": "Show all attempts",
  "暂无": "None",
  "暂无 HTTP 连接，请先在业务系统连接页面创建": "No HTTP connections yet; please create one on the System Connections page first",
  "暂无主体风险数据": "No partner risk data",
  "暂无交换": "No exchanges",
  "暂无匹配报文，请调整筛选时间或条件后重试": "No matching messages; adjust the time range or filters and try again",
  "暂无可切换企业": "No organizations to switch to",
  "暂无可用公钥": "No public key available",
  "暂无可用模型": "No models available",
  "暂无工作流引用": "Not used by any workflow",
  "暂无异常记录": "No exceptions",
  "暂无报文标识": "No message IDs yet",
  "暂无报文结构节点绑定该码表": "No structure nodes use this code list",
  "暂无数据": "No data",
  "暂无类型数据": "No type data",
  "暂无节点使用": "No nodes in use yet",
  "暂无节点使用，保留只读": "No nodes in use yet, kept read-only",
  "暂无配置变更审计记录": "No configuration audit records yet",
  "暂时取不到接入信息，请确认交换引擎在运行": "Access details unavailable; check the exchange engine is running",
  "更多操作": "More actions",
  "更换业务事件密钥？": "Replace the business event key?",
  "更换密钥": "Replace key",
  "更换证书": "Replace certificate",
  "更新": "Updated",
  "更新于": "Updated",
  "更新到草稿": "Update draft",
  "更新只改草稿里的目标结构，已配好的规则不动；差异列需要另行补规则后再发布。": "Updating only changes the target structure in the draft; configured rules stay. Add rules for changed columns before publishing.",
  "曾发生处理失败，经重处理后最终成功": "Failed earlier; succeeded after reprocessing",
  "最多出现": "Max occurrences",
  "最大请求体（字节）": "Max request body (bytes)",
  "最大连接池大小": "Maximum pool size",
  "最少出现": "Min occurrences",
  "最新活动时间": "Latest activity",
  "最新版本": "Latest version",
  "最终状态": "Final status",
  "最近": "Last",
  "最近交换": "Recent exchanges",
  "最近交换：": "Last exchange:",
  "最近更新": "Last updated",
  "月报（上月）": "Monthly (last month)",
  "有严重错误或回执积压的交易伙伴将被优先置顶显示": "Partners with severe errors or acknowledgement backlogs are shown first",
  "有人在你之后保存了这个映射。重新加载会放弃你尚未保存的修改。": "Someone saved this mapping after you. Reloading discards your unsaved changes.",
  "有值": "has value",
  "有尚未保存的修改": "Unsaved changes",
  "有差异": "Differs",
  "有效期至": "Valid until",
  "有效期至：": "Valid until: ",
  "有效期（年）": "Validity (years)",
  "有未保存的修改": "Unsaved changes",
  "有未保存的更改": "Unsaved changes",
  "有未发布修改": "Has unpublished changes",
  "有未解决失败": "Unresolved failures",
  "有未解决的失败报文或高等级预警": "Unresolved failed messages or high-level alerts",
  "有约定在生产收发": "Has agreements exchanging in production",
  "有问题 {0}": "Issues {0}",
  "有问题时拦截": "Block on issues",
  "有问题时记录并继续": "Record issues and continue",
  "服务名 (SERVICE_NAME)": "Service Name (SERVICE_NAME)",
  "服务名 / SID": "Service Name / SID",
  "服务器主机密钥指纹": "Server host key fingerprint",
  "服务器主机指纹：": "Server host fingerprint: ",
  "服务器未确认保存成功": "The server did not confirm the save",
  "服务器未确认创建成功": "The server did not confirm the creation",
  "服务器未确认删除成功": "The server did not confirm the delete",
  "服务模式": "Service mode",
  "期望伙伴的业务回复": "Expected business response from partner",
  "期望回复": "Expected reply",
  "未上线": "Not live",
  "未保存密码": "No password saved",
  "未匹配到工作流": "No matching workflow",
  "未匹配到约定": "No matching agreement",
  "未匹配时": "When unmatched",
  "未发布": "Unpublished",
  "未发送": "Not sent",
  "未变 {0}": "Unchanged {0}",
  "未启用": "Not enabled",
  "未启用的协议：": "Protocols not enabled:",
  "未填写": "Not set",
  "未处理": "Open",
  "未处理 + 处理中": "Open + in progress",
  "未处理预警": "Open alerts",
  "未完成": "Not done",
  "未完成设置": "Setup incomplete",
  "未应用": "Not applied",
  "未建约定": "No agreements",
  "未执行": "Not run",
  "未找到匹配的工作流模板": "No matching workflow templates found",
  "未找到匹配的节点类型": "No matching node types",
  "未找到该交易伙伴，可能已被移除": "Trading partner not found; it may have been removed",
  "未映射 {0}": "Unmapped {0}",
  "未查询到与业务单号 \"{0}\" 相关的出入站报文记录，请核对单号是否正确。": "No inbound or outbound messages found for \"{0}\"; check the reference.",
  "未测试": "Not tested",
  "未绑定伙伴": "No partner bound",
  "未被引用": "Not referenced",
  "未认领": "Unclaimed",
  "未设基准": "No baseline",
  "未设置": "Not set",
  "未设置取值": "No value set",
  "未设置：伙伴不能向此端口推送": "Not set: the partner cannot push to this port",
  "未读取到有效的码值数据": "No valid codes found",
  "未运行": "Not run",
  "未选择业务流程": "No business flow selected",
  "未配置": "Not configured",
  "未配置中文译名": "No Chinese name configured",
  "未配置密钥": "Key not configured",
  "本应用尚未注册 AI 场景": "This application has no AI scenarios registered",
  "本方 AS2 ID": "Our AS2 ID",
  "本方 AS2 协议": "Local AS2 profile",
  "本方 FTP/FTPS 服务供伙伴上传、下载文件（建议 FTPS 显式 TLS）。": "Our FTP/FTPS service lets partners upload and download files (explicit TLS FTPS recommended).",
  "本方 Odette ID": "Our Odette ID",
  "本方 SFTP 服务供伙伴上传、下载文件；伙伴自己的 SFTP 服务器在其传输通道里配置。": "Our SFTP service lets partners upload and download files; a partner's own SFTP server is configured in its channel.",
  "本方协议": "Local profiles",
  "本方协议加载失败": "Failed to load local profiles",
  "本方协议是所有伙伴共用的本方站点设置：本方在信封里的代码、各协议的接收地址与证书。对接新伙伴时，把对应协议的「对接信息」发给对方即可；伙伴各自的地址与账号在伙伴的「传输通道」里配置。": "Local profiles are our site settings shared by all partners: our codes in envelopes and each protocol's receiving address and certificates. When onboarding a partner, send them the \"connection details\" of the protocol they use; each partner's own addresses and accounts go in its channels.",
  "本方安全证书": "Our security certificate",
  "本方实施": "Our implementation",
  "本方报文标识": "Our message IDs",
  "本方报文标识保存失败": "Failed to save our message IDs",
  "本方报文标识加载失败": "Failed to load our message IDs",
  "本方报文标识已保存": "Our message IDs saved",
  "本方报文标识用于报文头部的发送方/接收方代码，不同于下方各传输协议的端点配置。": "Our message IDs are the sender/receiver codes in message envelopes, separate from the protocol endpoints below.",
  "本方标识{0}": "Our ID{0}",
  "本方签名": "Our signing",
  "本方约定代码": "Our agreed code",
  "本方解密": "Our decryption",
  "本方限定符": "Our qualifier",
  "本方默认客户端身份（mTLS）": "Our default client identity (mTLS)",
  "材料类型": "Material type",
  "条": " ",
  "条件": "Condition",
  "条件分支": "Condition branch",
  "条规则": "rules",
  "来源": "Source",
  "查看": "View",
  "查看交换记录": "View interchanges",
  "查看超时工单": "View overdue work orders",
  "查看运行日志": "View run log",
  "查询": "Search",
  "标准": "Standard",
  "标准 FTP 或 FTPS 加密传输": "Standard FTP or encrypted FTPS transfer",
  "标准业务数据数组，每个元素是一票": "Array of canonical business data, one document per element",
  "标准业务数据（JSON）": "Canonical business data (JSON)",
  "标准体系": "Standard family",
  "标准包预检失败": "Standard package pre-check failed",
  "标准定义文件已导入": "Standard definition file imported",
  "标准详情加载失败，请检查后端服务与登录状态": "Failed to load standard details; check the backend service and login",
  "标记为不需要": "Mark as not needed",
  "标题": "Title",
  "校验": "Verification",
  "校验、回执与时效": "Validation, acknowledgements and timing",
  "校验不通过时": "When validation fails",
  "校验于": "Verified at",
  "校验内容": "Checks",
  "校验对象": "Checked content",
  "校验异常": "Validation issue",
  "校验类型": "Check type",
  "校验结果{0}": "Validation result{0}",
  "校验证书": "Verify TLS certificate",
  "校验问题": "Validation issues",
  "样例中有值但未使用": "Has a value in the sample but unused",
  "样例名称": "Sample name",
  "样例已添加": "Sample added",
  "样例票数": "Sample documents",
  "核实总重": "Verified gross mass",
  "核对": "Check",
  "核对分隔符（UNA）与字符集（UNB 语法标识，如 UNOC）是否与约定一致；常见原因是释放字符 ? 未转义、缺段终止符或文件被截断。": "Check that the delimiters (UNA) and character set (UNB syntax ID, e.g. UNOC) match the agreement; common causes are an unescaped release character ?, a missing segment terminator or a truncated file.",
  "根目录": "Root folder",
  "格式/长度": "Format / length",
  "格式或长度不符": "Format or length mismatch",
  "检查": "Check",
  "检查发现 {0} 个错误": "Check found {0} errors",
  "检查未通过，修正下列错误后才能发布": "Check failed; fix the errors below before publishing",
  "检查通过": "Check passed",
  "检查通道": "Check channels",
  "检索交换引擎处理过的出入站报文": "Search inbound and outbound messages processed by the exchange engine",
  "概览": "Overview",
  "模型设置": "Model settings",
  "模式": "Mode",
  "模式（Schema）": "Schema",
  "模拟工具": "Simulator",
  "模板": "Templates",
  "模板名称": "Template name",
  "模板已删除": "Template deleted",
  "模板已重命名": "Template renamed",
  "模板说明（可选）": "Template description (optional)",
  "次": "times",
  "次数": "Count",
  "欢迎使用": "Welcome",
  "止:": "To:",
  "正在切换企业...": "Switching organization...",
  "正在加载 EDI 自由工作流...": "Loading EDI workflow...",
  "正在加载官方定义…": "Loading official definition…",
  "正在处理登录...": "Signing in...",
  "正在对比…": "Comparing…",
  "正在推导收发方代码...": "Deriving sender and receiver codes...",
  "正在显示个人信息（已记入操作审计）": "Showing personal data (recorded in the operation audit)",
  "正在查看 v{0}（只读）：{1}": "Viewing v{0} (read-only): {1}",
  "正在校验…": "Verifying…",
  "正在跳转...": "Redirecting...",
  "正常": "Valid",
  "正常流转": "Normal",
  "此尝试失败，已由尝试 {0}（": "This attempt failed; attempt {0} (",
  "此映射用于 {0}，与所选报文定义不配套": "This mapping is for {0} and does not match the selected message definition",
  "步骤": "Step",
  "段": "Segment",
  "段不在定义中或顺序不对": "Segment not in definition or out of order",
  "段代码为 3 位大写字母，如 RFF": "Segment codes are 3 upper-case letters, e.g. RFF",
  "段功能说明": "Segment function",
  "段在报文之外": "Segment outside a message",
  "段定义": "Segment definitions",
  "段组": "Segment group",
  "段组代码如 SG3": "Segment group codes like SG3",
  "每一行都必须填写 internalCode、nameZh、standardSource": "Every row must have internalCode, nameZh and standardSource",
  "每个对象写入后读回比对一致，才清除数据库中的副本；失败的记录留在数据库，下次归档自动重试": "Each object is read back and compared after writing before the database copy is removed; failed records stay in the database and are retried next time",
  "沉淀为知识条目": "Save as article",
  "没有 UNB 就无法识别发送方和接收方，因此不判断适用约定；结构与数据按同类型、同版本的报文定义检查。": "Without UNB the sender and receiver cannot be identified, so no agreement is matched; structure and data are checked against the definition of the same type and version.",
  "没有使用本次默认字段的主体协议端口。": "No protocol ports use the changed defaults.",
  "没有匹配的入站交换约定——平台收到这份报文时不会按约定处理。请检查发送方、接收方标识，或为该伙伴建立约定": "No matching inbound agreement — the platform would not process this message under an agreement. Check the sender and receiver IDs, or create an agreement for this partner",
  "没有匹配的工作流": "No matching workflows",
  "没有匹配的约定": "No matching agreement",
  "没有已启用的出站交换约定": "No enabled outbound agreements",
  "没有报文内容": "No message content",
  "没有校验问题": "No validation issues",
  "没有符合条件的审计记录": "No matching audit records",
  "没有等待回执的测试交换，先在上方以业务系统身份发送一票": "No test interchanges awaiting acknowledgement; first send one above as the business system",
  "没有记录数据": "No data recorded",
  "没有输出": "No output",
  "没有错误": "No errors",
  "活动日志将在后续版本开放": "Activity log will be available in a later version",
  "活跃预警": "Active alerts",
  "派生并编辑": "Derive and edit",
  "派生新版本以编辑": "Derive new version to edit",
  "派生草稿版本": "Derive draft version",
  "流程控制": "Flow control",
  "测试": "Test",
  "测试 {0}": "Test {0}",
  "测试交换": "Test interchange",
  "测试交换不计入上方异常报文数，但失败了仍需处理，所以留在待处理中": "Test exchanges are left out of the error count above, but a failed one still needs handling, so it stays here",
  "测试交换（UNB 测试标记）：伙伴联调或收发模拟产生，不计入看板统计": "Test interchange (UNB test indicator): from partner testing or the simulator; not counted on the dashboard",
  "测试交换（UNB 测试标记，伙伴联调与收发模拟产生）默认不计入统计；待处理异常始终包含": "Test interchanges (UNB test indicator, from partner testing and the simulator) are excluded by default; open issues are always included",
  "测试交换（测试联调约定，或带测试标志的交换）只会进入这里，永远不会进入上面的生产业务流程": "Test exchanges (on test agreements, or flagged as test) only go here and never reach the production business flow above",
  "测试区间内没有带测试标志的交换": "No interchanges flagged as test in this period",
  "测试失败": "Test failed",
  "测试成功": "Test succeeded",
  "测试流程不能与生产业务流程相同": "The test flow cannot be the production business flow",
  "测试流程请选择测试环境的连接": "Please select a test-environment connection for test workflows",
  "测试流程（可选）": "Test flow (optional)",
  "测试环境": "Test environment",
  "测试联调": "Testing",
  "测试联调中": "In testing",
  "测试连接": "Test connection",
  "测试连通性": "Test connection",
  "测试：只收发测试交换（UNB 测试标志 = 1），联调通过后切为生产。生产约定会拒收带测试标志的交换。": "Test: exchanges only test interchanges (UNB test indicator = 1); switch to production after testing. Production agreements reject interchanges flagged as test.",
  "浏览器不允许写剪贴板，请逐项复制": "The browser does not allow clipboard access; copy each item",
  "浏览器拦截了弹出窗口，请允许后重试": "The browser blocked the pop-up; allow it and try again",
  "海运装运指示标准 (IFTMIN)": "Ocean shipping instruction (IFTMIN)",
  "添加": "Add",
  "添加 / 更新": "Add / update",
  "添加一个样例，改动规则时会自动用它预览结果": "Add a sample; results are previewed with it whenever you change rules",
  "添加伙伴码值": "Add partner code",
  "添加子节点": "Add child node",
  "添加对照": "Add mapping",
  "添加日期": "Add date",
  "添加标识": "Add ID",
  "添加样例": "Add sample",
  "添加步骤": "Add step",
  "添加第一个节点": "Add first node",
  "添加节点": "Add node",
  "添加表达式（高级）": "Add expression (advanced)",
  "添加规则": "Add rule",
  "添加请求头": "Add header",
  "添加转换函数": "Add transform function",
  "添加过滤条件": "Add filter condition",
  "添加连接参数": "Add connection parameter",
  "添加通道": "Add channel",
  "添加顶层节点": "Add top-level node",
  "清空": "Clear",
  "港口码头": "Port terminal",
  "源 → 目标": "Source → target",
  "源值": "Source value",
  "源字段": "Source field",
  "源字段在可重复记录中，这里只取第一条": "The source field is in a repeating record; only the first one is taken here",
  "源字段在可重复记录中，这里只取第一条。需要每条都取时，把目标改为列表并建立循环。": "The source field is in a repeating record; only the first one is taken. To take each one, make the target a list and create a loop.",
  "源校验和": "Source checksum",
  "源结构": "Source structure",
  "源自 {0}": "From {0}",
  "点击定位至该节点": "Click to locate the node",
  "点击节点": "Click a node",
  "点击重命名工作流": "Click to rename the workflow",
  "热存储（数据库）": "Hot storage (database)",
  "热期": "Hot period",
  "版本说明": "Version notes",
  "版本（配置 / 运行）": "Version (config / running)",
  "物流场站": "Depot / logistics yard",
  "状态": "Status",
  "状态正常": "Healthy",
  "状态的交换约定并启用，用模拟工具或伙伴测试文件联调": "mode, enable it, and test with the simulator or the partner's test files",
  "环境": "Environment",
  "现象": "Symptom",
  "现象：{0}": "Symptom: {0}",
  "生产": "Production",
  "生产 {0}": "Production {0}",
  "生产环境": "Production environment",
  "生产运行": "In production",
  "生成": "Generate",
  "生成后重新读取的报文，即伙伴将收到的内容": "The generated message read back, i.e. what the partner will receive",
  "生成并发出的报文": "Generated and sent messages",
  "生成报文": "Generate message",
  "生成推送令牌": "Generate push token",
  "生成文件": "Generated file",
  "生成方式": "Generated by",
  "生成时间": "Generated at",
  "生成样例": "Generate sample",
  "生成的报文": "Generated message",
  "生效配置": "Effective config",
  "用于保护生成的 .pfx 私钥证书；PFX 与密码均由平台主密钥加密保存，供运行时使用。": "Protects the generated .pfx private key certificate; the PFX and password are stored encrypted with the platform master key for runtime use.",
  "用于报文头部的发送方与接收方身份标识": "Sender and receiver identities used in message envelopes",
  "用户 ID：{0}": "User ID: {0}",
  "用户名": "User name",
  "用户名密码（Basic）": "User name and password (Basic)",
  "用报文诊断检查我方发出的原文，定位对应段与元素。": "Check our original with message diagnosis to find the segment and element.",
  "用途": "Usage",
  "用途、伙伴 MIG 中的约定等": "Purpose, agreements in the partner's MIG, etc.",
  "由 {0} 派生，用于在线调整结构": "Derived from {0} for editing the structure online",
  "由「报文解析」节点选择的报文定义决定，与收发方一起匹配伙伴报文": "Decided by the message definition chosen in the \"Parse message\" node; matched with sender and receiver to find partner messages",
  "由协议网关按该端口的协议（SFTP、HTTP、AS2…）收发；不选则使用平台收发目录": "Sent and received by the protocol gateway using the port's protocol (SFTP, HTTP, AS2…); leave empty to use the platform exchange folders",
  "由另一位有发布权限的成员审核：通过即发布；退回需写原因，版本回到草稿后可继续修改。": "Reviewed by another member with publishing permission: approval publishes; rejection needs a reason and returns the version to draft for further changes.",
  "由另一位有审核权限的同事审核": "To be reviewed by another colleague with review permission",
  "由引擎填写，不可编辑": "Filled by the engine, not editable",
  "画布导航": "Canvas navigation",
  "留在这里": "Stay",
  "留空使用本方默认": "Empty = our default",
  "留空则始终使用映射的最新发布版本": "Leave empty to always use the latest published mapping version",
  "留空时按伙伴与方向自动命名": "Named automatically from partner and direction when empty",
  "留空用连接的默认目录": "Leave blank to use the connection default directory",
  "留空表示不修改": "Leave empty to keep unchanged",
  "留空表示信任对端首次给出的密钥。": "Leave empty to trust the key the host presents first.",
  "留空：启用时固定为当时的最新发布版本；之后发布新版本不会自动影响本约定": "Leave empty to pin the latest published version at enable time; later versions do not affect this agreement automatically",
  "登录凭证无效": "Invalid sign-in credentials",
  "登录回调处理失败，请重新登录。": "Sign-in callback failed; please sign in again.",
  "登录失败": "Sign-in failed",
  "登录失败锁定阈值": "Lockout after failed logins",
  "登录密码": "Login password",
  "登录授权无效": "Invalid sign-in authorization",
  "登录授权未完成": "Sign-in authorization incomplete",
  "登录服务未返回有效凭证，请重新登录。": "The sign-in service returned no valid credentials; please sign in again.",
  "登录状态已失效": "Session expired",
  "登录状态无效": "Invalid sign-in state",
  "登录请求中缺少授权信息，请重新登录。": "The sign-in request lacks authorization; please sign in again.",
  "登录请求已失效，请重新登录。": "The sign-in request has expired; please sign in again.",
  "登录账号": "Login account",
  "登记伙伴": "Register partner",
  "登记并继续配置": "Register and continue",
  "登记报文标识": "Register message IDs",
  "监听中": "Listening",
  "监听地址": "Listen address",
  "监听端口": "Listen port",
  "目录": "Folders",
  "目标值": "Target value",
  "目标字段": "Target field",
  "目标结构": "Target structure",
  "目标结构类型": "Target structure type",
  "相关知识": "Related knowledge",
  "相对路径": "Relative path",
  "相对路径必须以 / 开头": "Relative path must start with /",
  "看平台会如何读这份文件：信封、适用约定、校验问题与解析结构。只诊断，不处理、不发送": "See how the platform reads this file: envelope, matching agreement, validation issues and parsed structure. Diagnosis only — nothing is processed or sent",
  "知识库": "Knowledge base",
  "知识库里还没有同类问题的处理方法；处理完后可以沉淀一条": "No method for this kind of problem in the knowledge base yet; save one after handling it",
  "短信": "SMS",
  "码值不在码表内": "Code not in code list",
  "码值字典 CSV 已下载": "Code dictionary CSV downloaded",
  "码值对照": "Code mapping",
  "码值对照缺失（港口、箱型、包装等）时到码值字典补齐对照。": "When a code mapping is missing (port, container type, package…), add it in the code dictionary.",
  "码值对照记录已保存": "Code mapping saved",
  "码值：{0}": "Code: {0}",
  "确定": "OK",
  "确定删除此模板？": "Delete this template?",
  "确定删除此节点吗？": "Delete this node?",
  "确认业务系统已调用业务事件接口发出；发送失败的按对应预警处理。": "Confirm the business system called the business event API; handle failed sends per their alerts.",
  "确认要用的": "Confirm the",
  "禁用（DISABLE）": "Disable (DISABLE)",
  "离开会丢失尚未保存的修改。": "Leaving loses your unsaved changes.",
  "私钥": "Private key",
  "私钥 (OpenSSH / PEM)": "Private key (OpenSSH / PEM)",
  "私钥口令 (Passphrase)": "Passphrase",
  "私钥如无口令可留空": "Leave blank if the private key has no passphrase",
  "私钥已由系统安全保存；导入 CA 签发证书时选择这条证书申请申请即可自动绑定。": "The private key is stored securely; when importing the CA-issued certificate, pick this request and it is bound automatically.",
  "私钥认证": "Private key authentication",
  "私钥证书下载失败": "Failed to download private key certificate",
  "私钥证书密码": "Private key certificate password",
  "私钥证书已导出并下载": "Private key certificate exported and downloaded",
  "私钥证书（受保护）": "Private key certificate (protected)",
  "秒": "s",
  "租户环境已变更，系统将自动刷新": "The organization changed; the page will refresh",
  "稍后": "Later",
  "空映射": "Empty mapping",
  "空白": "Blank",
  "空白工作流": "Blank workflow",
  "空白工作流没有接收或发送节点；在画布上添加后，在节点里选择交易伙伴": "A blank workflow has no receive or send node; add them on the canvas and select the partner in the node",
  "空闲超时（秒）": "Idle timeout (s)",
  "立即归档": "Archive now",
  "立即生成": "Generate now",
  "站内信": "In-app message",
  "端口": "Port",
  "端口名称": "Port name",
  "端口配置 JSON": "Port configuration JSON",
  "笔业务报文": "business messages",
  "符合报文定义，没有发现问题": "Conforms to the message definition; no issues found",
  "第 {0} 行「{1}」代码不能包含空格": "Code in row {0} ({1}) must not contain spaces",
  "第 {0} 行「{1}」代码不能超过 35 个字符": "Code in row {0} ({1}) must be at most 35 characters",
  "第 {0} 行本方约定代码不能包含空格": "Our code in row {0} must not contain spaces",
  "第 {0} 行本方约定代码不能超过 35 个字符": "Our code in row {0} must be at most 35 characters",
  "第 {0} 行本方约定限定符不能包含空格": "Our qualifier in row {0} must not contain spaces",
  "第 {0} 行本方约定限定符不能超过 8 个字符": "Our qualifier in row {0} must be at most 8 characters",
  "第 {0} 行限定符不能包含空格": "Qualifier in row {0} must not contain spaces",
  "第 {0} 行限定符不能超过 8 个字符": "Qualifier in row {0} must be at most 8 characters",
  "等于": "equals",
  "等待中": "Pending",
  "等待审核": "Awaiting review",
  "等待责任人": "Awaiting owner",
  "签名": "Signing",
  "签名摘要": "Signature digest",
  "签名私钥由密钥库加密保存；需要时可从私钥证书行导出受密码保护的 PFX。": "The signing private key is stored encrypted in the key store; export a password-protected PFX from the private key certificate row when needed.",
  "签名私钥证书": "Signing private key certificate",
  "签名算法": "Signature algorithm",
  "签名证书": "Signing certificate",
  "签名证书密码无需填写": "No password needed for the signing certificate",
  "签名证书（ED25519）": "Signing certificate (ED25519)",
  "签名（ED25519）": "Signing (ED25519)",
  "签字：": "Signature:",
  "简体中文": "Simplified Chinese",
  "简单数据元带了组成部分": "Simple data element has components",
  "简要说明模板适用场景": "Briefly describe the template scenario",
  "简要说明此工作流的用途与对接系统": "Briefly describe the purpose of this workflow and target systems",
  "简要说明此模板的适用场景和链路构成": "Briefly describe when to use it and what the flow does",
  "算法": "Algorithm",
  "算法 / 指纹": "Algorithm / fingerprint",
  "管理约定": "Manage agreements",
  "箱动态": "Container events",
  "箱号": "Container no.",
  "箱型": "Type",
  "箱进出场": "Gate in / out",
  "类型": "Type",
  "类型与功能": "Type and function",
  "类型变化": "Type changed",
  "粘贴 JSON": "Paste JSON",
  "粘贴伙伴发来的文件，例如\nUNA:+.? '\nUNB+UNOC:3+FWDSHA:ZZZ+CARRIER:ZZZ+260924:1200+IC000123'\n…": "Paste the partner's file, e.g.\nUNA:+.? '\nUNB+UNOC:3+FWDSHA:ZZZ+CARRIER:ZZZ+260924:1200+IC000123'\n…",
  "粘贴伙伴的 EDIFACT 交换或国标平台文件，或先选择约定生成样例": "Paste the partner's EDIFACT interchange or national standard platform file, or choose an agreement to generate a sample",
  "粘贴或上传文件后点「诊断」": "Paste or upload a file, then click \"Diagnose\"",
  "系统异常": "System issue",
  "系统资源不足": "System resources low",
  "紧急": "Critical",
  "紧急 {0}": "Critical {0}",
  "紧急预警": "Critical alerts",
  "繁體中文": "Traditional Chinese",
  "约定名称": "Agreement name",
  "约定已保存为草稿": "Agreement saved as draft",
  "约定已启用，引擎按新配置收发": "Agreement enabled; the engine now exchanges with the new settings",
  "约定的校验方式为「拦截并告警」时，有问题的报文不会进入业务流程，平台按约定回复拒绝回执": "When the agreement's validation is \"Block and alert\", messages with issues do not enter the business flow and the platform replies with a rejection as agreed",
  "组": "Group",
  "组成数据元过多": "Too many component data elements",
  "组织单位 (OU)": "Organizational unit (OU)",
  "组织名称 (Organization)": "Organization (O)",
  "终端 IP": "Client IP",
  "结构": "Structure",
  "结构已就绪": "Structure ready",
  "结构类型": "Structure type",
  "结构节点": "Structure nodes",
  "结果": "Result",
  "统一管理端到端业务集成流程，掌握每条链路的运行状态。": "Manage end-to-end integration flows and see how each one is running.",
  "统计区间": "Period",
  "编号或前缀": "ID or prefix",
  "编码字符集": "Character set",
  "编辑": "Edit",
  "编辑交换约定 · {0}": "Edit agreement · {0}",
  "编辑交易伙伴": "Edit trading partner",
  "编辑基本信息": "Edit basic info",
  "编辑报文标识": "Edit message IDs",
  "编辑知识条目": "Edit article",
  "编辑节点": "Edit node",
  "编辑连接": "Edit connection",
  "编辑通道": "Edit channel",
  "缩小画布": "Zoom out",
  "缺失数据：{0}": "Missing data: {0}",
  "缺少 UNB": "UNB missing",
  "缺少 UNH": "UNH missing",
  "缺少 UNT": "UNT missing",
  "缺少 UNZ": "UNZ missing",
  "缺少必备段": "Mandatory segment missing",
  "缺少必备段组": "Mandatory segment group missing",
  "缺报文标识": "Missing message ID",
  "缺省值": "Default value",
  "网关定时到此目录取件；存档成功后移入其下 processed/。不填则不取件": "The gateway collects files from this folder on a schedule and moves them to processed/ after archiving. Leave empty to not collect",
  "网关对外的根地址（协议 + 域名，不含路径）；伙伴推送地址为此地址 + /edi/v1/inbound/{通道编号}。": "The gateway's public root address (scheme and host, no path); partners push to this address + /edi/v1/inbound/{channel id}.",
  "网络不通、HTTP 5xx 或 429 时重试，间隔逐次加长；其他 4xx 视为业务系统拒收，不重试": "Retried with growing intervals on network errors, HTTP 5xx or 429; other 4xx mean the business system rejected it and are not retried",
  "网络错误，请检查网络连接后重试": "Network error; check your connection and retry",
  "置空": "Set empty",
  "美东（ET）": "US East (ET)",
  "美西（PT）": "US West (PT)",
  "联系伙伴确认是否收到；未收到则「补发」（原控制号不变）。": "Ask the partner whether they received it; if not, \"Resend\" (same control reference).",
  "联调测试报告": "Test report",
  "联调通过后点「上线」切为生产": "After testing passes, click \"Go live\" to switch to production",
  "能力": "Capability",
  "自动重试已用尽": "Automatic retries exhausted",
  "自定义": "Custom",
  "自定义区间": "Custom period",
  "自定义表格": "Custom table",
  "自定义请求头密钥": "Custom header secret",
  "自然日累计": "Since midnight",
  "自由拖拽": "Free dragging",
  "自由连线": "Free connections",
  "自签名证书已创建，私钥已安全保存": "Self-signed certificate created; the private key is stored securely",
  "自适应居中": "Fit and center",
  "至{0}": "to {0}",
  "至少写一条处理步骤": "Write at least one step",
  "船公司": "Carrier",
  "船司、码头、场站、货代等与本方交换 EDI 的伙伴：按上线进度跟进配置，按健康状态处理异常。": "Carriers, terminals, depots, forwarders and others exchanging EDI with us: follow configuration by onboarding progress and handle issues by health.",
  "节假日（推算的截单落在这些日期时提前一天）": "Holidays (a derived cut-off on these dates moves one day earlier)",
  "节点": "Node",
  "节点名称": "Node name",
  "节点已更新": "Node updated",
  "节点已添加": "Node added",
  "节点插件": "Node plugins",
  "节点编码": "Node code",
  "节点路径": "Node path",
  "英国（GMT/BST）": "UK (GMT/BST)",
  "英文名称": "English name",
  "草稿": "Draft",
  "草稿 {0}": "Draft {0}",
  "草稿 · 基于 v{0}": "Draft · based on v{0}",
  "草稿 · 未发布": "Draft · unpublished",
  "草稿会恢复为 v{0}": "The draft reverts to v{0}",
  "草稿保存失败": "Failed to save draft",
  "草稿已保存": "Draft saved",
  "草稿，字段待对照标准原文核对": "Draft; fields still to be checked against the standard text",
  "草稿，未发布": "Draft, not published",
  "荷兰 / 鹿特丹（CET）": "Netherlands / Rotterdam (CET)",
  "补发": "Resend",
  "补发原因 (必填)": "Resend reason (required)",
  "补发报文确认": "Confirm resend",
  "表单": "Form",
  "表结构与草稿里的快照一致，无需更新": "The table structure matches the draft snapshot; nothing to update",
  "表结构会连同映射一起保存，表变动后用映射设计器里的「刷新表结构」对比": "The table structure is saved with the mapping; after the table changes, compare with \"Refresh table structure\" in the mapping designer",
  "表结构刷新失败": "Failed to refresh table structure",
  "表达式": "Expression",
  "被 {0} 个工单采用 · 更新于{1}": "Used by {0} work orders · updated {1}",
  "被 {0} 条规则使用": "Used by {0} rules",
  "被动模式 (PASV)": "Passive mode (PASV)",
  "被动模式公告地址": "Passive mode public address",
  "被动端口范围": "Passive port range",
  "装卸报告": "Load / discharge report",
  "装卸船指令": "Loading / discharge order",
  "要求伙伴回复 CONTRL": "Require CONTRL from partner",
  "要求签名 MDN": "Require signed MDN",
  "覆盖配置必须是 JSON 对象": "Override configuration must be a JSON object",
  "规则": "Rule",
  "规则数": "Rules",
  "规则模板编码": "Rule template code",
  "规则没有变化": "No rule changes",
  "规则设置": "Rule settings",
  "视频生成": "Video generation",
  "解密私钥证书": "Decryption private key certificate",
  "解析报文头": "Parse header",
  "解析结构": "Parsed structure",
  "解码": "Decode",
  "解除关联": "Unlink",
  "解除证书关联": "Unlink certificate",
  "触发": "Trigger",
  "触发总数": "Total triggers",
  "触发次数": "Triggers",
  "言語": "言語",
  "語言": "Language",
  "订舱": "Booking",
  "订舱号": "Booking no.",
  "订舱号、提单号、箱号、SI 编号或订单号": "Booking, B/L, container, SI or order number",
  "订舱申请": "Booking request",
  "订舱确认": "Booking confirmation",
  "订舱确认给出截单时间时以它为准，按下面的时区解读；未给时按开航前小时数推算，落在节假日的提前到前一个工作日。": "A cut-off given in the booking confirmation wins and is read in the time zone below; otherwise it is derived from hours before departure, moved to the previous working day when it falls on a holiday.",
  "认证": "Authentication",
  "认证 / 凭据": "Authentication / Credentials",
  "认证方式": "Authentication method",
  "记录": "Log",
  "记录为知识条目": "Record as article",
  "记录类型": "Record types",
  "记录问题后继续": "Record the issues and continue",
  "记录问题后继续：问题写入处理记录，报文照常": "Record and continue: issues are written to the processing record and the message",
  "设为基准": "Set as baseline",
  "设置 {0}": "Set up {0}",
  "设置本方协议": "Set up local profile",
  "证书": "Certificate",
  "证书 {0} 的新版本已导入": "New version of certificate {0} imported",
  "证书中心中的客户端证书编号": "Client certificate ID in the certificate center",
  "证书到期": "Certificate expiry",
  "证书即将在 30 天内过期": "Certificate will expire within 30 days",
  "证书名称": "Certificate name",
  "证书密码（如文件设置了密码）": "Certificate password (if the file has one)",
  "证书已关联到当前伙伴": "Certificate linked to this partner",
  "证书文件": "Certificate file",
  "证书材料": "Certificate material",
  "证书材料仍保留在证书中心，只是不再属于「{0}」。": "The certificate stays in the certificate center; it just no longer belongs to \"{0}\".",
  "证书材料已删除": "Certificate material deleted",
  "证书材料已重命名": "Certificate material renamed",
  "证书用途": "Certificate usage",
  "证书申请": "Certificate request",
  "证书管理员邮箱": "Certificate administrator email",
  "证书轮换: {0}": "Certificate rotation: {0}",
  "证书颁发者：": "Issuer: ",
  "识别约定": "Identify agreement",
  "诊断": "Diagnose",
  "诊断原文": "Diagnose original",
  "该伙伴暂未绑定任何证书": "No certificates linked to this partner yet",
  "该单据存在未解决的处理失败": "This document has unresolved processing failures",
  "该场景不允许租户修改模型": "Tenants may not change the model for this scenario",
  "该官方标准包已导入，未重复写入": "This official package was already imported; nothing written again",
  "该报文与此前已投递的报文内容完全相同（SHA-256 匹配），未再次投递业务系统。": "This message is identical to one already delivered (SHA-256 match) and was not delivered to the business system again.",
  "该报文只有这一个库版本，没有可对比的版本。": "This message has only one library version; nothing to compare.",
  "该报文存在更新的处理尝试，请在最新尝试上操作": "This message has a newer attempt; act on the latest attempt",
  "该报文已由后续尝试处理成功，无需重处理": "This message was already processed by a later attempt; no need to reprocess",
  "该报文已通过补发成功送达": "This message was delivered by resending",
  "该报文无原始内容": "This message has no original content",
  "该报文未关联有效工作流，无法重新处理": "This message has no valid workflow and cannot be reprocessed",
  "该版本缺少模板标识，暂不能设为默认版本": "This version has no template ID and cannot be the default yet",
  "该版本还没有结构节点": "This version has no structure nodes yet",
  "该约定使用国标平台文件，一个文件只能有一票：每票会单独成文件发送": "This agreement uses national standard platform files, which hold one document per file: each document is sent as its own file",
  "该节点无需额外业务参数设置。": "This node needs no extra business settings.",
  "该规则按场景与报文状态触发，没有可调的阈值。": "This rule fires on scenario and message status; it has no adjustable threshold.",
  "该连接已被工作流引用，删除将被系统拒绝。": "This connection is referenced by workflows; deletion will be refused.",
  "语法": "Syntax",
  "语法回执": "Syntax acknowledgement",
  "语法回执（CONTRL）": "Syntax acknowledgement (CONTRL)",
  "语法错误代码": "Syntax error code",
  "语言": "Language",
  "语音转文本": "Speech to text",
  "说明": "Details",
  "说明（可选）": "Notes (optional)",
  "请与对方管理员核对指纹后再信任": "Please verify the fingerprint with the administrator before trusting",
  "请仔细核对以上影响面，确认无误后继续。": "Review the impact above carefully before continuing.",
  "请先保存协议草稿": "Save the profile draft first",
  "请先停用工作流": "Disable the workflow first",
  "请先在「{0}」节点选择报文定义": "Select a message definition in the \"{0}\" node first",
  "请先在发送节点选择接入伙伴": "Select a partner in the send node first",
  "请先在接收节点选择接入伙伴": "Select a partner in the receive node first",
  "请先在编辑器中配置节点": "Configure nodes in the editor first",
  "请只选择同一报文类型、同一方向的约定": "Select agreements of one message type and one direction only",
  "请填写 http:// 或 https:// 开头的地址": "Enter a URL starting with http:// or https://",
  "请填写{0}": "Fill in {0}",
  "请填写原因": "Enter a reason",
  "请填写推送地址": "Enter the push URL",
  "请填写时限": "Enter the time limit",
  "请填写第 {0} 行「{1}」的代码": "Enter the code in row {0} ({1})",
  "请填写第 {0} 行「{1}」的伙伴代码": "Enter the partner code in row {0} ({1})",
  "请填写证书中心的证书引用": "Enter a certificate reference from the certificate center",
  "请对方把此公钥加入 authorized_keys": "Please ask the partner to add this public key to authorized_keys",
  "请拖入具体的字段，记录只能拖到列表目标上生成循环": "Drag a specific field; records can only be dragged onto list targets to create loops",
  "请检查模板结构后重试": "Check the template structure and try again",
  "请求体": "Request body",
  "请求体（POST 表单参数）": "Request body (POST form parameters)",
  "请求失败": "Request failed",
  "请求失败 ({0})": "Request failed ({0})",
  "请求失败！": "Request failed!",
  "请求头": "Request headers",
  "请求头名称": "Header name",
  "请求格式": "Request format",
  "请求语法回执": "Syntax acknowledgement requested",
  "请求错误，请重试": "Request error, please retry",
  "请现在复制并通过安全渠道发给伙伴；平台只保存其摘要，关闭后无法再次查看。伙伴推送地址：": "Copy it now and send it to the partner over a secure channel; the platform keeps only its digest and it cannot be shown again. Partner push address:",
  "请确认工作流存在且拥有访问权限": "Check that the workflow exists and you have access",
  "请粘贴 JSON": "Paste JSON",
  "请粘贴新证书 PEM 内容": "Paste the new certificate PEM",
  "请粘贴更新颁发的公钥证书 PEM 内容...": "Paste the PEM of the newly issued public certificate...",
  "请详细说明补发依据（如：客户反映未收到 SFTP 提单文件，经双方确认执行重新推送）": "Explain why (e.g. customer did not receive the SFTP B/L file; both sides agreed to push it again)",
  "请输入 HTTPS 地址": "Enter an HTTPS URL",
  "请输入 JSON 配置": "Enter the JSON configuration",
  "请输入 PFX 密码": "Enter the PFX password",
  "请输入 PFX 私钥证书密码": "Enter the PFX private key certificate password",
  "请输入 SSH 主机密钥材料 ID": "Enter the SSH host key material ID",
  "请输入 http(s) 地址": "Enter an http(s) URL",
  "请输入{0}": "Enter {0}",
  "请输入主机名或 IP": "Enter a host name or IP",
  "请输入主机地址": "Enter the host address",
  "请输入主机密钥指纹": "Please enter host key fingerprint",
  "请输入代码": "Enter a code",
  "请输入令牌": "Please enter token",
  "请输入令牌地址": "Please enter token URL",
  "请输入伙伴 AS2 URL": "Enter the partner AS2 URL",
  "请输入伙伴 AS2 标识": "Enter the partner AS2 ID",
  "请输入伙伴名称": "Enter the partner name",
  "请输入伙伴编码": "Enter the partner code",
  "请输入参数名": "Please enter parameter name",
  "请输入名称": "Enter a name",
  "请输入基础地址": "Please enter base URL",
  "请输入完整业务单号（如订舱号、提单号、箱号）": "Enter the full business reference (booking, B/L or container number)",
  "请输入客户端 ID": "Please enter client ID",
  "请输入客户端证书口令": "Please enter client certificate password",
  "请输入密码": "Enter the password",
  "请输入密钥": "Please enter secret",
  "请输入工作流名称": "Enter a workflow name",
  "请输入报文代码（1-35 字符，无空格）": "Enter the code (1–35 chars, no spaces)",
  "请输入控制端口": "Enter the control port",
  "请输入推送地址": "Enter the push URL",
  "请输入数据库名": "Enter the database name",
  "请输入新密码": "Please enter new password",
  "请输入新密钥": "Please enter new secret",
  "请输入新的 PFX 密码。密码仅用于本次导出，不会保存到平台。": "Enter a new PFX password. It is used only for this export and not stored.",
  "请输入新的节点名称": "Enter a new node name",
  "请输入新私钥": "Please enter new private key",
  "请输入新证书对应的本地密钥引用": "Enter the local key reference for the new certificate",
  "请输入有效的 URL": "Enter a valid URL",
  "请输入有效的异步 MDN URL": "Enter a valid async MDN URL",
  "请输入有效的接收 URL": "Enter a valid receiving URL",
  "请输入服务名或 SID": "Please enter service name or SID",
  "请输入本方 AS2 ID": "Enter our AS2 ID",
  "请输入本方 Odette ID": "Enter our Odette ID",
  "请输入样例名称": "Enter a sample name",
  "请输入根目录": "Enter the root folder",
  "请输入模板名称": "Enter a template name",
  "请输入用于导出 PFX 的密码": "Enter a password for exporting the PFX",
  "请输入用户名": "Enter the user name",
  "请输入监听地址": "Enter the listen address",
  "请输入监听端口": "Enter the listen port",
  "请输入端口": "Enter the port",
  "请输入端口名称": "Enter a port name",
  "请输入补发原因": "Enter the resend reason",
  "请输入请求体上限": "Enter the request body limit",
  "请输入请求头名称": "Please enter header name",
  "请输入连接名称": "Enter a connection name",
  "请输入重处理原因（如：工作流映射规则已更新修复）": "Enter the reason (e.g. mapping rule fixed in the workflow)",
  "请输入需要从官方包导入的报文类型": "Enter the message type to import from the official package",
  "请选择 ED25519 签名证书": "Select an ED25519 signing certificate",
  "请选择 TLS 私钥证书": "Select the TLS private key certificate",
  "请选择{0}": "Select {0}",
  "请选择业务流程": "Select a business flow",
  "请选择业务系统连接": "Please select a system connection",
  "请选择主体协议端口": "Select a party protocol port",
  "请选择交易伙伴": "Select a trading partner",
  "请选择伙伴": "Select a partner",
  "请选择协议": "Select a protocol",
  "请选择已开通此应用的企业，或返回工作台。": "Choose an organization that has this app, or return to the workbench.",
  "请选择报文定义": "Select a message definition",
  "请选择报文记录": "Select a message record",
  "请选择数据库连接": "Select a database connection",
  "请选择数据表": "Select a table",
  "请选择文件": "Select a file",
  "请选择映射": "Select a mapping",
  "请选择服务模式": "Select a service mode",
  "请选择本方 AS2 协议": "Select a local AS2 profile",
  "请选择源结构": "Select a source structure",
  "请选择环境": "Please select environment",
  "请选择目标结构": "Select a target structure",
  "请选择目标结构类型": "Select a target structure type",
  "请选择签名私钥证书": "Select the signing private key certificate",
  "请选择统计区间": "Select a period",
  "请选择要复制的映射": "Select the mapping to copy",
  "请选择解密私钥证书": "Select the decryption private key certificate",
  "请选择证书": "Select a certificate",
  "请选择证书文件": "Select a certificate file",
  "请选择证书用途": "Select the certificate usage",
  "请选择键列": "Select key columns",
  "读不到「{0}」的列结构，请确认连接可用、表仍存在": "Cannot read the columns of \"{0}\"; check the connection works and the table still exists",
  "调用示例": "Example call",
  "货物/箱状态": "Cargo / container status",
  "资源回到阈值以内后预警自动关闭。": "The alert closes automatically when resources are back within thresholds.",
  "起:": "From:",
  "起点": "Start from",
  "超时": "Timed out",
  "超时（秒）": "Timeout (s)",
  "距 SI / VGM 截单不足该时长仍未发送即预警": "Alert when SI / VGM is still not sent this long before the cut-off",
  "跟随最新": "Follow latest",
  "路由匹配": "Route match",
  "跳过": "Skipped",
  "跳过：{0}": "Skipped: {0}",
  "转入归档": "Archived",
  "转换": "Transform",
  "转换好的标准业务数据交给哪个业务流程投递到内部系统；同一业务过程的所有伙伴共用一个流程": "The business flow that delivers the canonical data to internal systems; all partners of the same business process share one flow",
  "转换步骤": "Transforms",
  "转换结果": "Mapping result",
  "轮换后的算法、有效期和指纹由新证书内容自动识别。": "Algorithm, validity and fingerprint are read from the new certificate.",
  "轮换解密证书": "Next decryption certificate",
  "输入业务单号查看全生命周期的报文交互轨迹、尝试记录与单据业务状态推断。": "Enter a business reference to see its full message history, attempts and inferred document status.",
  "输出 {0}": "Output {0}",
  "输出：": "Output:",
  "达梦": "DAMENG",
  "达梦数据库 DM7/DM8/DM9": "DAMENG Database DM7/DM8/DM9",
  "运行中": "Running",
  "运行中 v{0}": "Running v{0}",
  "运行全部": "Run all",
  "运行模式": "Run mode",
  "运行状况": "Operations",
  "运行稳定": "Running smoothly",
  "运行记录": "Run log",
  "运输状态": "Transport status",
  "近 24 小时": "Last 24 h",
  "近 24 小时报文": "Messages, last 24 h",
  "近 24 小时收发无失败": "No failures in the last 24 h",
  "近 24 小时未解决失败": "Unresolved failures, last 24 h",
  "近 30 天": "Last 30 days",
  "近 30 天生产报文": "Production messages, last 30 days",
  "近 7 天": "Last 7 days",
  "近 7 天处理量": "Volume, last 7 days",
  "近 7 天失败": "Failures, last 7 days",
  "近 {0} 天": "Last {0} days",
  "返回 2xx": "2xx response",
  "返回伙伴": "Back to partner",
  "返回伙伴列表": "Back to partners",
  "返回工作台": "Back to workbench",
  "返回工作流列表": "Back to workflows",
  "返回报文查询": "Back to message search",
  "返回映射列表": "Back to mappings",
  "返回草稿": "Back to draft",
  "返回选择类型": "Back to type selection",
  "还没有与该伙伴的交换，联调时可用模拟工具收发一轮": "No exchanges with this partner yet; use the simulator to run a round trip during testing",
  "还没有交换约定：为这个伙伴要收发的每种报文建一条约定即可上线": "No exchange agreements yet: create one for each message type this partner exchanges to go live",
  "还没有伙伴。先登记第一个船司、码头或场站，再按上线步骤配置通道和交换约定": "No partners yet. Register your first carrier, terminal or depot, then configure channels and agreements step by step",
  "还没有伙伴码值；在下方添加": "No partner codes yet; add one below",
  "还没有入站交换约定": "No inbound agreements yet",
  "还没有包含多份报文的交换。伙伴一个文件发来多份报文，或在「合并发送」中批量发出后会出现在这里": "No interchanges with several messages yet. They appear when a partner sends several messages in one file, or after a combined send in \"Batch send\"",
  "还没有基准。确认当前输出正确后设为基准，之后的修改会与它对比。": "No baseline yet. When the current output is right, set it as the baseline; later changes are compared with it.",
  "还没有已发布的本方 AS2 协议：先到「本方协议」配置本方 AS2 标识、接收地址与签名/解密证书并发布": "No published local AS2 profile yet: first configure our AS2 ID, receiving URL and signing/decryption certificates under \"Local profiles\" and publish",
  "还没有已启用的交换约定": "No enabled exchange agreements yet",
  "还没有归档任务": "No archive jobs yet",
  "还没有报表：开启定时生成或点「生成」": "No reports yet: turn on scheduled generation or click \"Generate\"",
  "还没有按交换约定收发的文件": "No files exchanged under agreements yet",
  "还没有数据库连接，请先到「连接」页添加": "No database connections yet; add one on the \"Connections\" page first",
  "还没有知识条目。处理完一个工单后，在工单里点「沉淀为知识条目」最省事": "No articles yet. The easiest way: after handling a work order, click \"Save as article\" in it",
  "还没有经过本工作流的报文": "No messages have passed through this workflow yet",
  "还没有通道：添加一个 AS2、OFTP2、SFTP 或 HTTP 通道后先点「测试」确认连通": "No channels yet: add an AS2, OFTP2, SFTP or HTTP channel and click \"Test\" to confirm connectivity",
  "还没有配置本方协议。伙伴用哪种方式与我方交换，就先配置哪种：": "No local profile yet. Configure the protocol partners will use to exchange with us:",
  "还没有？到工作流用「业务流程」模板新建并启用": "None yet? Create and enable one from the \"Business flow\" template in Workflow",
  "这一版改了什么、为什么改，例如：补充危险品闪点映射": "What changed and why, e.g. added mapping for dangerous goods flash point",
  "这是结构性节点；该节点不直接包含数据元。": "This is a structural node; it holds no data elements directly.",
  "进出门报告": "Gate report",
  "进行中": "In progress",
  "远程目录": "Remote directory",
  "连接": "Connections",
  "连接密码只写不读，保存后不再回显。": "Connection passwords are write-only and not shown after saving.",
  "连接已保存": "Connection saved",
  "连接已创建": "Connection created",
  "连接已删除": "Connection deleted",
  "连接类型": "Connection type",
  "连接超时": "Connect timeout",
  "连接超时（秒）": "Connection timeout (seconds)",
  "连通性": "Connectivity",
  "连通性测试详情": "Connectivity test details",
  "追溯查询": "Trace",
  "退回": "Reject",
  "退回 {0}": "Reject {0}",
  "退回草稿": "Return to draft",
  "适中自适应": "Fit to view",
  "适用的预警类型": "Applies to alert types",
  "适用约定": "Matching agreement",
  "选填": "Optional",
  "选填（默认本方代码）": "Optional (defaults to our code)",
  "选择 FTP / SFTP 连接": "Select FTP / SFTP connection",
  "选择 HTTP 连接": "Select HTTP connection",
  "选择一个版本查看结构差异（新增、修改的出现次数/必填/长度/格式、删除）。": "Select a version to see structural differences (added; changed occurrence/required/length/format; removed).",
  "选择一条工作流进入可视化编辑器": "Select a workflow to open the visual editor",
  "选择交换引擎提供的报文定义": "Select a message definition provided by the exchange engine",
  "选择交易伙伴": "Select trading partner",
  "选择交易伙伴与报文定义后自动推导收发方代码": "Sender and receiver codes are derived after selecting a partner and message definition",
  "选择伙伴": "Select partner",
  "选择入站约定（决定信封里的收发方）": "Select an inbound agreement (sets sender and receiver in the envelope)",
  "选择出站交换约定": "Select an outbound agreement",
  "选择出站约定（决定发给谁、用什么报文）": "Select an outbound agreement (sets recipient and message)",
  "选择判断新增还是更新的列": "Select the columns that decide insert or update",
  "选择协议端口": "Select protocol port",
  "选择多个源字段，取值为列表": "Select several source fields; the value is a list",
  "选择已启用的业务流程": "Select an enabled business flow",
  "选择或管理企业": "Choose or manage organizations",
  "选择报文标准": "Select message standard",
  "选择接入伙伴": "Select partner",
  "选择文件": "Choose file",
  "选择映射": "Select mapping",
  "选择服务端 TLS 证书": "Select the server TLS certificate",
  "选择本方有效私钥证书": "Select a valid local private key certificate",
  "选择本方签名证书": "Select our signing certificate",
  "选择本方解密证书": "Select our decryption certificate",
  "选择用于签发 X25519 交换材料的 ED25519 证书": "Select the ED25519 certificate that signs the X25519 exchange material",
  "选择要写入的数据库连接": "Select the database connection to write to",
  "选择要写入的数据表": "Select the table to write to",
  "选择要对比的版本": "Select a version to compare",
  "选择证书": "Select certificate",
  "选择证书中心已有材料": "Choose material from the certificate center",
  "选择证书文件": "Choose certificate file",
  "选择起点模板": "Choose a starting template",
  "选择预警类型": "Select alert types",
  "逐条 {0}": "Each {0}",
  "逐票发送结果": "Results per document",
  "通用": "General",
  "通用名称 (Common Name / FQDN)": "Common name (CN / FQDN)",
  "通知订舱客户尽快提交补料（SI）或核实总重（VGM）。": "Ask the booking customer to submit the shipping instruction (SI) or VGM as soon as possible.",
  "通过": "Passed",
  "通过并发布": "Approve and publish",
  "通过（仅转换，未投递）": "Passed (converted only, not delivered)",
  "通过（已发送）": "Passed (sent)",
  "通道": "Channels",
  "通道不通": "Channel down",
  "通道不通、失败报文或高等级预警": "Channel down, failed messages or high-level alerts",
  "通道不通：伙伴可能收不到报文": "Channel down: the partner may not receive messages",
  "通道已保存为审核草稿": "Channel saved as a draft for review",
  "通道心跳或投递失败，伙伴可能收不到报文": "Channel heartbeat or delivery failing; the partner may not receive messages",
  "通道心跳或投递连续失败。先在「传输通道」里测试连通，再到预警中心查看详情。": "Channel heartbeat or delivery keeps failing. Test connectivity under \"Channels\" first, then see the alert center for details.",
  "通道心跳或投递连续失败达到该次数即告警，恢复后自动关闭": "Alert when channel heartbeat or delivery fails this many times in a row; closes automatically on recovery",
  "通道编号 {0}": "Channel {0}",
  "邮件": "Email",
  "部分失败": "Partly failed",
  "配置": "Configuration",
  "配置中": "Configuring",
  "配置传输通道": "Configure channels",
  "配置已保存": "Configuration saved",
  "配置或测试联调中": "Configuring or testing",
  "配置状态": "Configuration status",
  "配置节点": "Configure node",
  "配置（通道、标识、证书）审核通过后才能启用；审核前约定只能测试联调": "Configuration (channels, IDs, certificates) can be enabled only after review; until then agreements can only be tested",
  "采用": "Use",
  "重命名": "Rename",
  "重命名模板": "Rename template",
  "重命名模板失败": "Failed to rename template",
  "重命名证书材料": "Rename certificate material",
  "重处理": "Reprocessed",
  "重处理与补发": "Reprocess and resend",
  "重处理原因 (选填)": "Reprocess reason (optional)",
  "重处理原因: {0}": "Reprocess reason: {0}",
  "重处理机制说明": "How reprocessing works",
  "重处理记录": "Reprocess records",
  "重复": "Duplicate",
  "重复拦截": "Duplicate blocked",
  "重复检查": "Duplicate check",
  "重复（已拦截）": "Duplicate (blocked)",
  "重排": "Rerank",
  "重排 Rerank": "Rerank",
  "重新加载": "Reload",
  "重新处理": "Reprocess",
  "重新处理报文": "Reprocess message",
  "重新校验": "Verify again",
  "重新生成样例": "Regenerate sample",
  "重新登录": "Sign in again",
  "重新隐藏": "Hide again",
  "重置": "Reset",
  "重置接入密钥？": "Reset the access key?",
  "重试": "Retry",
  "铁路联运": "Rail intermodal",
  "锁定时长（分钟）": "Lockout duration (min)",
  "错误": "Error",
  "错误 {0}": "Errors {0}",
  "错误: {0}": "Error: {0}",
  "错误代码": "Error code",
  "错误码": "Error code",
  "键列": "Key columns",
  "问题": "Issues",
  "问题代码": "Issue code",
  "问题解决后手工「补发」；补发需填写原因并留痕。": "After the problem is fixed, \"Resend\" manually; a resend needs a reason and is logged.",
  "防重发风险提示": "Duplicate risk",
  "阿联酋（UTC+4）": "UAE (UTC+4)",
  "附加请求头": "Extra headers",
  "附加连接参数": "Additional connection parameters",
  "降级": "Degraded",
  "降级运行": "Running degraded",
  "限定符": "Qualifier",
  "隐式 FTPS": "Implicit FTPS",
  "隐式 TLS（PORT 990）": "Implicit TLS (PORT 990)",
  "需优先响应": "Respond first",
  "需关注": "Needs attention",
  "需处理": "Needs action",
  "需要（REQUIRE，不验证书）": "Require (REQUIRE, no certificate verification)",
  "韩国（UTC+9）": "Korea (UTC+9)",
  "项": "Item",
  "预检通过：{0}，{1} 个结构节点": "Pre-check passed: {0}, {1} structure nodes",
  "预置": "Preset",
  "预置 · 只读": "Preset · read-only",
  "预置映射没有样例；复制为我的映射后可以添加": "Preset mappings have no samples; copy to my mappings to add some",
  "预览失败": "Preview failed",
  "预警": "Alerts",
  "预警与工单": "Alerts and work orders",
  "预警态势总览": "Alert overview",
  "预警类型": "Alert type",
  "预警级别": "Alert level",
  "预警触发趋势": "Alert trend",
  "预警触发趋势堆叠柱状图": "Stacked bar chart of alert triggers",
  "首次交互时间": "First exchange",
  "首次发布，共": "First publication,",
  "首次失败原因: {0}；最新尝试已处理成功": "First failure: {0}; the latest attempt succeeded",
  "首记录 00、尾记录 99、记录顺序与出现次数、尾记录的记录总数": "Header record 00, trailer record 99, record order and occurrences, record count in the trailer",
  "首记录位置不对": "Header record in wrong position",
  "首选（PREFER）": "Prefer (PREFER)",
  "验证（VERIFY，验证证书与主机名）": "Verify (VERIFY, verify certificate and hostname)",
  "高": "High",
  "高级筛选": "Advanced filters",
  "高级设置（SSL、超时、连接池与附加参数）": "Advanced settings (SSL, timeouts, pool size, and parameters)",
  "高级设置（TLS 加密、传输模式与超时）": "Advanced settings (TLS encryption, transfer mode, and timeouts)",
  "高级设置（TLS、双向证书、代理与附加请求头）": "Advanced settings (TLS, mTLS, proxy, and extra headers)",
  "高级设置（主机指纹、远程目录与超时）": "Advanced settings (host fingerprint, remote directory, and timeouts)",
  "高级：JSON": "Advanced: JSON",
  "高风险交易伙伴": "High-risk partners",
  "默认更新影响预览": "Default change impact preview",
  "默认远程目录": "Default remote directory",
  "（process、partner 与 items：每项一个 eventId和一票标准业务数据）。这里用同一接口手工演练： EDIFACT约定下所有票合并成一个交换（一个 UNB、每票一对UNH…UNT、一个交换控制号）；有问题的票单独记录为未发送，不影响其他票；重复的 eventId返回原记录，不会重复发送。": " (process, partner and items: one eventId and one business document per item). Try the same endpoint by hand here: under an EDIFACT agreement all documents go into one interchange (one UNB, one UNH…UNT pair per document, one control reference); a problem document is recorded as not sent without affecting the others; a repeated eventId returns the original record and is not sent again.",
  "（共 {0} 次处理尝试）": " ({0} processing attempts)",
  "（另有 {0} 条建链前的历史记录不在链内）": " ({0} older records from before the chain are not in it)",
  "（含测试 {0}）": " (incl. {0} test)",
  "（官方）": " (official)",
  "（执行器未接入）": "(executor not connected)",
  "（按发生时间先后正序排列）": " (in order of occurrence)",
  "（按旧工作流处理）": " (processed by legacy workflow)",
  "（无）": "(none)",
  "（未启用）": " (not enabled)",
  "（未生效）": " (not effective)",
  "（测试）": " (test)",
  "（空）": "(empty)",
  "（草稿定义）": " (draft definition)",
  "（预置不够就在映射设计器复制一份调整）": "to use (copy and adjust one in the mapping designer if the presets are not enough)",
  "）处理成功": ") succeeded",
  "，{0} 审核于{1}": ", {0} reviewed at {1}",
  "，伙伴": ", partner",
  "，未通过 {0} 份": ", {0} not passed",
  "，请求头": ", request header",
  "：业务系统调用业务事件接口时只需这两项和业务数据。": ": a business system needs only these two and the business data when calling the business event API.",
  "：从节点右侧的【出站】圆点拖出连接线到另一个节点的【入站】圆点。": ": drag from a node's \"out\" dot on the right to another node's \"in\" dot.",
  "：条件节点提供【满足】与【不满足】两个独立输出端口。": ": condition nodes have separate \"matched\" and \"not matched\" outputs.",
  "：点击工具栏的【自动排版】按钮即可自适应对齐整理。": ": click \"Auto layout\" in the toolbar to align everything.",
  "：点击节点间或分支末端的": ": click the",
  "：自动根据条件分为【满足】与【不满足】双链路。": ": splits automatically into \"matched\" and \"not matched\" paths.",
  "：选中节点并展开右侧属性设置面板。": ": select it and open the settings panel on the right.",
  "：鼠标左键拖动节点卡片调整在画布中的任意位置。": ": drag a node card with the left mouse button to place it anywhere.",
  "：鼠标滚轮缩放，按住画布拖动平移。": ": scroll to zoom, drag the canvas to pan.",
  "「{0}」{1} 取哪些记录": "Which {1} records ({0}) to take",
  "全部记录（不筛选）": "All records (no filter)",
  "限定符值": "Qualifier values",
  "这是一个列表。把一个可重复记录从左侧拖到这一行，或在下面选择，对每条记录生成一个列表元素。": "This is a list. Drag a repeating record from the left onto this row, or pick one below, to create one list element per record.",
  "这是一个对象，可以直接映射下面的字段。需要按限定符从某类记录中取一条（例如取发货人）时，在下面选择那类记录。": "This is an object; you can map the fields below directly. To fill it from one record picked by qualifier (for example the shipper), choose that record type below.",
  "选择可重复记录": "Choose a repeating record",
  "这个列表上有 {0} 个循环，当前是第 {1} 个。每个循环各自输出一组元素，例如每种日期限定符输出一个 DTM。": "This list has {0} loops; this is loop {1}. Each loop writes its own elements, for example one DTM per date qualifier.",
  "取第一条满足条件的源记录填入这个对象": "Fill this object from the first matching source record",
  "在同一列表上再加一个循环": "Add another loop on this list",
  "规则 {0}": "Rule {0}",
  "源字段在可重复记录中，这里只取第一条。需要按限定符取特定的一条时在上面设置筛选；需要每条都取时，把目标改为列表并建立循环。": "The source field is in a repeating record, so only the first one is taken. To take a specific one by qualifier, set a filter above; to take every one, map to a list with a loop.",
  "按条件再加一条规则": "Add another conditional rule",
  "同一字段的规则按顺序执行，后面有值的会覆盖前面的结果，请给每条设置不同的条件。": "Rules on the same field run in order and a later value overwrites an earlier one, so give each rule its own condition.",
  "同一目标上的第 {0} 个循环，共 {1} 个": "Loop {0} of {1} on this target",
  "这个字段有 {0} 条规则，按顺序执行": "This field has {0} rules, run in order",
  "对象上只能拖入可重复记录，取第一条满足条件的记录；字段请拖到下面的具体字段上": "Only a repeating record can be dropped on an object (the first matching record fills it); drop fields on the fields below",
  "取第一条 ← {0} ({1})": "First of ← {0} ({1})",
  "合并 {0} 个字段": "{0} fields combined",
  "常量 {0}": "Constant {0}",
  "有条件": "Conditional",
  "{0} 步转换": "{0} transform steps",
  "缺省 {0}": "Default {0}",
  "输出一个元素 · 当 {0}": "One element · when {0}",
  "输出一个元素": "One element",
  "当前记录（只输出一个元素）": "Current record (one element only)",
  "按名称自动匹配": "Auto-match by name",
  "应用选中的 {0} 项": "Apply {0} selected",
  "只为还没有规则的目标字段给出建议，已配置的规则不会被改动。高置信度且源字段未被占用的建议已默认勾选，其余请逐条确认。": "Suggestions cover only target fields without rules; existing rules are left alone. High-confidence suggestions whose source is not already used are ticked; confirm the rest one by one.",
  "这个源字段已被其他规则使用，或同时被建议给多个目标": "This source is already used by another rule or suggested for several targets",
  "置信度": "Confidence",
  "依据": "Basis",
  "没有找到可信的匹配建议": "No reliable suggestions found",
  "全部展开": "Expand all",
  "全部折叠": "Collapse all",
  "折叠的字段中有样例值未被使用": "Some folded fields have sample values that are not used",
  "自动匹配": "Auto-match",
  "字段名一致": "Same field name",
  "中文名一致": "Same label",
  "{0}/{1} 个关键词一致": "{0}/{1} keywords match",
  "中文名相近": "Similar label",
  "已添加 {0} 条规则": "Added {0} rules",
  "拖到目标字段，或选中目标后双击": "Drag onto a target, or select a target and double-click",
  "先在中间选中一个目标字段，再双击源字段": "Select a target field in the middle first, then double-click a source field",
  "映射的码表转换读取引擎中的副本；平时每次修改都会自动同步，引擎数据异常时可手动重新同步": "Mapping code conversion reads the engine's copy. Every edit is synced automatically; sync by hand if the engine's copy looks wrong.",
  "{0} 个码表同步失败：{1}": "{0} code tables failed to sync: {1}",
  "已从码值字典同步 {0} 个码表": "Synced {0} code tables from the dictionary",
  "码表同步失败": "Code table sync failed",
  "同步到引擎": "Sync to engine",
  "引用共享码表": "Use a shared code table",
  "选择码表": "Choose a code table",
  "没有已同步的码表": "No synced code tables",
  "码表「{0}」尚未同步到引擎": "Code table {0} has not been synced to the engine",
  "{0} 个码值，{1} 个伙伴有自己的代码": "{0} codes; {1} partners have their own codes",
  "伙伴代码 → 标准代码": "Partner code → standard code",
  "标准代码 → 伙伴代码": "Standard code → partner code",
  "按当前报文的伙伴": "Partner of the current message",
  "从码值字典同步": "Sync from the code dictionary",
  "码表转换": "Code table",
  "码表转换按这个伙伴的代码预览；不选时只认标准代码": "Code tables convert with this partner's codes in the preview; without one, only standard codes are recognised",
  "预览伙伴": "Preview partner",
  "码表 {0}": "Code table {0}",
  "导出映射说明书（Excel 可直接打开的 CSV）": "Export the mapping specification (CSV that opens in Excel)",
  "说明书": "Specification",
  "由引擎填写": "Filled by the engine",
  "序号": "No.",
  "目标路径": "Target path",
  "作用域（循环来源）": "Scope (loop source)",
  "取值": "Value",
  "限定符筛选": "Qualifier filter",
  "映射名称": "Mapping",
  "版本": "Version",
  "当前记录": "Current record",
  "是": "Yes",
  "标记为不需要的源字段": "Source fields marked as not needed",
  "排序": "Sort",
  "按源记录原顺序": "Keep source order",
  "升序": "Ascending",
  "降序": "Descending",
  "去重": "De-duplicate",
  "不去重": "Keep duplicates",
  "分组汇总": "Group and total",
  "不分组": "No grouping",
  "每组输出一条；组内汇总用“多个字段”选“组内全部 · 字段”，再加求和、计数等列表函数。": "One element per group. To total a group, use Multiple fields with \"All in group · field\" and add a list function such as sum or count.",
  "拆分成多条": "Split into several",
  "分隔符，如 ; 或 \\n": "Separator, e.g. ; or \\n",
  "每段长度": "Length per part",
  "循环来源选一个文本字段，按分隔符和长度拆开，每段一条，循环内用“拆分出的片段 value”取值。常用于长备注拆成多个 FTX。": "Pick a text field as the loop source; it is cut by separator and length into one element per part, read inside the loop as \"Split part value\". Typically used to spread a long remark over several FTX segments.",
  "当前时间（可再加日期格式转换）": "Current time (add a date format step if needed)",
  "循环内序号（第几条，从 1 起）": "Position in the loop (from 1)",
  "拆分出的片段 value": "Split part value",
  "组内全部 · {0}  $group[].{1}": "All in group · {0}  $group[].{1}",
  "循环选项": "Loop options",
  "系统值": "System value",
  "伙伴差异": "Partner-specific",
  "有 {0} 处伙伴差异无法套用到 v{1}": "{0} partner differences could not be applied to v{1}",
  "新增的规则「{0}」所在的循环已不在基线中": "The loop holding the added rule {0} is no longer in the base",
  "修改过的规则「{0}」已不在基线中": "The changed rule {0} is no longer in the base",
  "已升级到基线 v{0}，伙伴差异已保留": "Moved to base v{0}; partner differences kept",
  "已派生伙伴映射，只需修改与基线不同的规则": "Partner variant created; change only what differs from the base",
  "派生失败": "Could not create the variant",
  "伙伴派生映射：只维护与基线不同的规则，标“伙伴差异”的行是这个伙伴自己的规则": "Partner variant: only rules that differ from the base are maintained here; rows marked Partner-specific are this partner's own",
  "{0} 派生 · 基于 {1} v{2}": "{0} variant · based on {1} v{2}",
  "升级到基线 v{0}？": "Move to base v{0}?",
  "基线的新规则会带过来，伙伴差异会重新套用": "The base's new rules come along and the partner differences are applied again",
  "基线有新版本 v{0}": "Base has v{0}",
  "同一种报文各伙伴略有不同时，基于这个映射的已发布版本派生，只修改不同的规则；基线更新后可一键升级": "When partners differ slightly for the same message, derive from this mapping's published version and change only what differs; move to a newer base in one click",
  "派生伙伴映射": "Derive partner variant",
  "派生": "Derive",
  "基线": "Base",
  "当前时间": "Current time",
  "循环内序号": "Position in loop",
  "基于 {0} v{1} 派生": "Derived from {0} v{1}",
  "伙伴派生 · {0}": "Partner variant · {0}",
  "{0} 等": "{0} and more",
  "拖拽或双击填入": "Drag, or double-click to fill",
  "拖动调整高度": "Drag to resize",
  "展开测试面板": "Expand test panel",
  "收起测试面板": "Collapse test panel",
  "列名": "Column name",
  "如 booking_no": "e.g. booking_no",
  "中文名": "Column label",
  "如 订舱号": "e.g. Booking No",
  "格式": "Format",
  "上移": "Move up",
  "下移": "Move down",
  "编辑列": "Edit columns",
  "有 {0} 条规则写入这些列，保存后这些规则会在检查中报错": "{0} rules write to these columns; after saving, these rules will produce errors during check",
  "添加列": "Add column",
  "{0} / {1} 列": "{0} / {1} columns",
  "先定义表格的列": "Define table columns first",
  "表格列数最多不能超过 {0} 列": "Table cannot have more than {0} columns",
  "列名不能为空": "Column name cannot be empty",
  "列名格式不合法，需以字母或下划线开头，由字母、数字或下划线组成且不超过 64 个字符": "Invalid column name; must start with a letter or underscore, consist of letters, digits or underscores, and not exceed 64 characters",
  "列名「{0}」重复": "Duplicate column name \"{0}\"",
  "中文名不能为空": "Column label cannot be empty",
  "列类型不合法": "Invalid column type",
  "已更新表格列": "Table columns updated",
  "表格名称": "Table name",
  "请输入表格名称": "Please enter table name",
  "表格名称不能超过 64 个字符": "Table name cannot exceed 64 characters",
  "在映射设计器中定义具体列，可作为 Excel 输出节点的数据源": "Define specific columns in the mapping designer; can be used as a data source for the Excel output node",
  "例如：订舱导出表": "e.g. Booking export table",
  "Excel 输出": "Excel output",
  "把映射出的数据行写成 Excel 文件，放到平台发件目录或经 FTP / SFTP 连接投递": "Write mapped data rows into an Excel file and save to the platform outbox directory or deliver via FTP / SFTP connection",
  "平台发件目录 · {0}": "Platform outbox · {0}",
  "支持占位符：{messageId}、{businessKey}、{date}、{time}、{date:yyyyMMdd}": "Supported placeholders: {messageId}, {businessKey}, {date}, {time}, {date:yyyyMMdd}",
  "没有可用的连接，请先到「连接」页添加": "No available connections; please add one in the Connections page first",
  "只列出从「{0}」业务数据出发的已发布映射": "Only published mappings from {0} business data are listed",
  "已生效（网关 OFTP2 站点接收/发送）": "Active (gateway OFTP2 station send/receive)",
  "伙伴与平台 OFTP2 站点建立会话，本方作为文件发送方/接收方；需配置本方 Odette ID 及可选私钥证书。": "The partner establishes an OFTP2 session with the platform station; our party acts as file originator/destination. Configure our Odette ID and optional private key certificate.",
  "平台 OFTP2 接入信息（给伙伴）": "Platform OFTP2 Access Information (for partner)",
  "平台 OFTP2 站点尚未配置": "Platform OFTP2 station is not configured yet",
  "伙伴配置我方时：会话 ID 填平台站点 ID，文件发送方/接收方填本方 Odette ID。当前平台站点环境变量未设定，但仍可保存与发布本方配置。": "When partners configure our connection: session ID uses the platform station ID, file originator/destination uses our Odette ID. Platform station environment variables are currently unset, but local configuration can still be saved and published.",
  "伙伴配置我方时：会话 ID 填平台站点 ID，文件发送方/接收方填本方 Odette ID": "When partners configure our connection: session ID uses platform station ID, file originator/destination uses our Odette ID",
  "平台站点 SSID": "Platform Station SSID",
  "标准端口（明文）": "Standard Port (plain)",
  "TLS 端口": "TLS Port",
  "Odette ID 需为 1-25 位大写字母、数字或特殊字符（空格 / - . & ( )）": "Odette ID must be 1-25 characters (upper case letters, digits, space, / - . & ( ))",
  "RFC 5024 规范，1-25 位大写字符（支持字母、数字及空格 / - . & ()），各租户全局唯一": "RFC 5024 specification, 1-25 upper case characters (letters, digits, space / - . & ()), unique across all tenants",
  "可选；需同时放入平台部署密钥库。仅限有效的本方私钥证书。": "Optional; must also be placed into the platform deployment keystore. Valid local private certificates only.",
  "选择本方有效私钥证书（可选）": "Select our valid private certificate (optional)",
  "还没有已发布的本方 OFTP2 协议：先到「本方协议」配置本方 Odette ID 并发布": "No published OFTP2 protocol profile yet: go to 'Local Profiles' to configure and publish our Odette ID first",
  "伙伴 Odette ID": "Partner Odette ID",
  "请输入伙伴 Odette ID": "Enter partner Odette ID",
  "RFC 5024 规范，1-25 位大写字符": "RFC 5024 specification, 1-25 upper case characters",
  "最多 8 个字符（双方建立 OFTP2 会话时验证）": "At most 8 characters (verified during OFTP2 session handshake)",
  "主动轮询间隔（分钟）": "Active Poll Interval (minutes)",
  "可选，≥ 1：定时主动呼叫伙伴以收取文件或 EERP 回执": "Optional, >= 1: periodically poll partner to collect files or EERP receipts",
  "要求签名 EERP": "Require Signed EERP",
  "伙伴公钥证书": "Partner Public Certificate",
  "出站签名、加密或要求签名 EERP 时必选伙伴公钥证书": "Partner public certificate is required when outbound signing, encryption, or signed EERP is enabled",
  "出站签名/加密/签名 EERP 时必选；仅限有效的伙伴公钥证书": "Required when outbound signing/encryption/signed EERP is enabled; valid partner public certificates only",
  "选择伙伴公钥证书": "Select partner public certificate",
  "受信任 TLS 根证书": "Trusted TLS CA / Server Certificate",
  "可选：伙伴服务端证书或其自建 CA 根证书（TLS 验证）": "Optional: partner server certificate or custom CA certificate (for TLS verification)",
  "选择受信任 TLS 证书": "Select trusted TLS certificate",
  "虚拟文件名（Virtual File Name）": "Virtual File Name",
  "虚拟文件名限 1-26 位大写字母、数字或连字符（-）": "Virtual file name must be 1-26 upper case letters, digits, or hyphens (-)",
  "可选，1-26 位大写字符；未填则自动推导": "Optional, 1-26 upper case characters; auto-derived from filename if unset",
  "记录格式（Record Format）": "Record Format",
  "通常为非格式化二进制（U）": "Usually unstructured binary (U)",
  "非格式化（U - Unstructured）": "Unstructured (U - Unstructured)",
  "文本行记录（T - Text）": "Text with records (T - Text)",
  "密码最多 8 个字符": "Password must not exceed 8 characters",
  "传输回执": "Transport receipt",
  "OFTP2 EERP 或 AS2 MDN：对方传输系统是否确认收到文件": "OFTP2 EERP or AS2 MDN: whether the partner's transfer software confirmed receipt of the file",
  "传输编号": "Transport reference",
  "发出时间": "Sent at",
  "应答截止": "Receipt due",
  "回执时间": "Receipt time",
  "签名/加密证书": "Signing / encryption certificate",
  "TLS 证书": "TLS certificate",
  "下载": "Download",
  "派生单据失败": "Failed to derive business document",
  "派生业务单据": "Derive business document",
  "基础单据": "Base document",
  "基础主版本": "Base major version",
  "请选择基础主版本": "Please select base major version",
  "请输入单据编码": "Please enter document code",
  "以小写字母开头，仅包含小写字母、数字和连字符，长度 2-64": "Start with a lowercase letter, contain only lowercase letters, digits and hyphens, length 2-64",
  "请输入单据名称": "Please enter document name",
  "企业订舱单": "Enterprise booking confirmation",
  "导入内容不能为空": "Import content cannot be empty",
  "推断字段失败": "Failed to infer fields",
  "创建单据失败": "Failed to create document",
  "新建业务单据": "New business document",
  "推断提示": "Inference note",
  "到货通知": "Arrival notice",
  "结构起点": "Structure starting point",
  "从 JSON 样例导入": "Import from JSON sample",
  "从 JSON Schema 导入": "Import from JSON Schema",
  "JSON Schema 内容": "JSON Schema content",
  "JSON 样例内容": "JSON sample content",
  "请输入导入内容": "Please enter import content",
  "解析并推断字段": "Parse and infer fields",
  "已推断 {0} 个顶级字段": "Inferred {0} top-level fields",
  "新建单据": "New document",
  "派生自「{0}」": "Derived from '{0}'",
  "企业自建": "Custom document",
  "已发布版本": "Published versions",
  "添加顶级字段": "Add root field",
  "添加子字段": "Add child field",
  "添加同级字段": "Add sibling field",
  "字段名称": "Field name",
  "请输入字段名称": "Please enter field name",
  "以字母或下划线开头，仅含字母、数字和下划线": "Start with a letter or underscore, contain only letters, digits and underscores",
  "请输入中文名": "Please enter Chinese name",
  "可重复（数组）": "Repeated (array)",
  "输入码值后按回车": "Press Enter after entering each code",
  "保存草稿失败": "Failed to save draft",
  "检查兼容性失败": "Failed to check compatibility",
  "已切换到新主版本 v{0} 草稿": "Switched to new major version v{0} draft",
  "切换新主版本失败": "Failed to switch to new major version",
  "草稿已提交审核": "Draft submitted for review",
  "提交审核失败": "Failed to submit for review",
  "草稿已删除": "Draft deleted",
  "删除草稿失败": "Failed to delete draft",
  "审核通过并已发布到引擎": "Approved and published to the exchange engine",
  "审核发布失败": "Failed to approve and publish",
  "退回时请写明原因": "Please specify reason for rejection",
  "版本已退回": "Version rejected",
  "退回失败": "Failed to reject",
  "新草稿已创建": "New draft created",
  "创建草稿失败": "Failed to create draft",
  "暂无已发布版本，请在「草稿」中编辑并提交审核发布。": "No published versions yet. Please edit in Draft and submit for review to publish.",
  "以下变更与当前主版本不兼容，请修改或改为发布新主版本：": "The following changes are incompatible with the current major version. Please adjust or publish as a new major version:",
  "变更类型": "Change kind",
  "字段路径": "Field path",
  "变更前": "Before",
  "变更后": "After",
  "上次审核退回原因：{0}": "Previous rejection reason: {0}",
  "选择叶子字段作为业务单号": "Select a leaf field as the business key",
  "检查兼容": "Check compatibility",
  "确定要删除此草稿吗？删除后不可恢复。": "Are you sure you want to delete this draft? This action cannot be undone.",
  "删除草稿": "Delete draft",
  "平台功能依赖此字段，派生单据不可删改": "Platform features depend on this field; derived documents cannot delete or modify it",
  "核心字段已预置码值不可移除": "Preset codes of core fields cannot be removed",
  "确定删除此字段？": "Are you sure you want to delete this field?",
  "版本历史": "Version history",
  "已有打开的草稿或审核中版本，不能新建草稿": "An open draft or version under review already exists; cannot create a new draft",
  "新建修订": "New revision",
  "新建主版本": "New major version",
  "主版本": "Major version",
  "修订版本": "Revision",
  "关联映射 {0}": "Linked mapping {0}",
  "关联约定 {0}": "Linked agreement {0}",
  "关联业务流程 {0}": "Linked business flow {0}",
  "退回原因": "Rejection reason",
  "请填写退回原因，退回后版本回到草稿状态": "Please provide the reason for rejection; the version will return to draft status",
  "检查兼容性": "Check compatibility",
  "改为发布新主版本 v{0}": "Switch to publish new major version v{0}",
  "关闭": "Close",
  "草稿与主版本 v{0} 兼容": "Draft is compatible with major version v{0}",
  "所有变更均为向后兼容变更，发布时将作为此主版本的新修订。": "All changes are backward compatible and will be published as a new revision of this major version.",
  "草稿与主版本 v{0} 不兼容": "Draft is incompatible with major version v{0}",
  "存在不兼容变更。若继续修改请按提示调整，或直接点击下方「改为发布新主版本」。": "Incompatible changes exist. Please adjust as indicated or click below to publish as a new major version.",
  "选择要修订的主版本": "Select major version to revise",
  "核心字段被删除": "Core field removed",
  "核心字段类型变更": "Core field type changed",
  "核心字段重复性变更": "Core field repeated changed",
  "核心字段码值被删除": "Core field code removed",
  "业务单号字段变更": "Business key field changed",
  "字段被删除": "Field removed",
  "字段类型变更": "Field type changed",
  "字段重复性变更": "Field repeated changed",
  "可选字段变为必填": "Optional field became required",
  "必填字段变为可选": "Required field became optional",
  "中文名变更": "Label changed",
  "语义标签变更": "Semantic role changed",
  "码值被删除": "Code removed",
  "码值新增": "Code added",
  "新增必填字段": "Required field added",
  "新增字段": "Field added",
  "请输入伙伴主机名或 IP": "Please enter partner hostname or IP",
  "TLS": "TLS",
  "会话密码": "Session password",
  "安全": "Security",
  "出站签名": "Outbound signature",
  "出站加密": "Outbound encryption",
  "出站压缩": "Outbound compression",
  "文件": "File",
  "公网主机/域名": "Public host / domain",
  "本方证书": "Our certificate",
  "例如：O0013000MYCORP": "e.g. O0013000MYCORP",
  "请先选择接入伙伴": "Please select a partner first",
  "无法获取原映射结构信息": "Unable to retrieve original mapping structure",
  "已创建映射副本并打开设计器": "Mapping copy created and designer opened",
  "复制映射失败，请重试": "Failed to copy mapping, please retry",
  "复制一份为该伙伴调整": "Copy a version for this partner",
  "已切换为拦截模式": "Switched to blocking mode",
  "已切换为观察模式": "Switched to observe mode",
  "切换检查模式失败": "Failed to switch check mode",
  "确认切换为拦截模式？": "Confirm switching to blocking mode?",
  "开启拦截后，存在业务数据问题的调用将被直接退回业务系统。最近 {0} 天有 {1} 条出站报文如果开启拦截将被拒绝：": "Once blocking is enabled, calls with business data issues will be directly rejected back to the business system. In the last {0} days, {1} outbound messages would have been rejected:",
  "确认开启拦截": "Confirm enable blocking",
  "开启拦截后，数据不合格的调用将直接退回业务系统。当前无异常出站报文。": "Once blocking is enabled, calls with non-compliant data will be directly rejected back to the business system. There are currently no abnormal outbound messages.",
  "业务数据检查": "Business data check",
  "观察（只记录，不拦截）": "Observe (log only, no blocking)",
  "拦截（数据不合格直接退回业务系统）": "Block (reject non-compliant data back to business system)",
  "最近 {0} 天有 {1} 条出站报文存在业务数据问题": "In the last {0} days, {1} outbound messages had business data issues",
  " · 已有 {0} 个伙伴使用": " · Used by {0} partners",
};

export default en;
